
import React from 'react';
import loadable from '@loadable/component';
import Skeleton from 'react-loading-skeleton';

          const Accordion = loadable(() =>
            import(
              /* webpackChunkName: "Accordion" */
              '../components/Accordion/Accordion.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Accordion_styles = loadable(() =>
            import(
              /* webpackChunkName: "Accordion.styles" */
              '../components/Accordion/Accordion.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const AccordionSection = loadable(() =>
            import(
              /* webpackChunkName: "AccordionSection" */
              '../components/AccordionSection/AccordionSection.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const AccordionSection_styles = loadable(() =>
            import(
              /* webpackChunkName: "AccordionSection.styles" */
              '../components/AccordionSection/AccordionSection.styles.js'
            ),
            { fallback: <Skeleton /> }
          );
import AlertRibbon from '../components/AlertRibbon/AlertRibbon.jsx';

          const AlertRibbon_styles = loadable(() =>
            import(
              /* webpackChunkName: "AlertRibbon.styles" */
              '../components/AlertRibbon/AlertRibbon.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ArticleGrid = loadable(() =>
            import(
              /* webpackChunkName: "ArticleGrid" */
              '../components/ArticleGrid/ArticleGrid.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ArticleGrid_styles = loadable(() =>
            import(
              /* webpackChunkName: "ArticleGrid.styles" */
              '../components/ArticleGrid/ArticleGrid.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const BackgroundImageWithTextTop = loadable(() =>
            import(
              /* webpackChunkName: "BackgroundImageWithTextTop" */
              '../components/BackgroundImageWithTextTop/BackgroundImageWithTextTop.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const BackgroundImageWithTextTop_styles = loadable(() =>
            import(
              /* webpackChunkName: "BackgroundImageWithTextTop.styles" */
              '../components/BackgroundImageWithTextTop/BackgroundImageWithTextTop.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Banner = loadable(() =>
            import(
              /* webpackChunkName: "Banner" */
              '../components/Banner/Banner.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Banner_styles = loadable(() =>
            import(
              /* webpackChunkName: "Banner.styles" */
              '../components/Banner/Banner.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const BeautifulBeanFootageTVSvg = loadable(() =>
            import(
              /* webpackChunkName: "BeautifulBeanFootageTVSvg" */
              '../components/BeautifulBeanFootageTVSvg/BeautifulBeanFootageTVSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const BeautifulBeanFootageTVSvg_styles = loadable(() =>
            import(
              /* webpackChunkName: "BeautifulBeanFootageTVSvg.styles" */
              '../components/BeautifulBeanFootageTVSvg/BeautifulBeanFootageTVSvg.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const BlogAccordion = loadable(() =>
            import(
              /* webpackChunkName: "BlogAccordion" */
              '../components/BlogAccordion/BlogAccordion.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const BlogAccordion_styles = loadable(() =>
            import(
              /* webpackChunkName: "BlogAccordion.styles" */
              '../components/BlogAccordion/BlogAccordion.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const BlogAccordionSection = loadable(() =>
            import(
              /* webpackChunkName: "BlogAccordionSection" */
              '../components/BlogAccordionSection/BlogAccordionSection.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const BlogAccordionSection_styles = loadable(() =>
            import(
              /* webpackChunkName: "BlogAccordionSection.styles" */
              '../components/BlogAccordionSection/BlogAccordionSection.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const BlueyBeanChallenge = loadable(() =>
            import(
              /* webpackChunkName: "BlueyBeanChallenge" */
              '../components/BlueyBeanChallenge/BlueyBeanChallenge.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const BlueyBeanChallenge_styles = loadable(() =>
            import(
              /* webpackChunkName: "BlueyBeanChallenge.styles" */
              '../components/BlueyBeanChallenge/BlueyBeanChallenge.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const CallToAction = loadable(() =>
            import(
              /* webpackChunkName: "CallToAction" */
              '../components/CallToAction/CallToAction.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const CallToAction_styles = loadable(() =>
            import(
              /* webpackChunkName: "CallToAction.styles" */
              '../components/CallToAction/CallToAction.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const CareersHero = loadable(() =>
            import(
              /* webpackChunkName: "CareersHero" */
              '../components/CareersHero/CareersHero.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const CareersHero_styles = loadable(() =>
            import(
              /* webpackChunkName: "CareersHero.styles" */
              '../components/CareersHero/CareersHero.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SvgBorder = loadable(() =>
            import(
              /* webpackChunkName: "SvgBorder" */
              '../components/CareersHero/SvgBorder/SvgBorder.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const CareersLocations = loadable(() =>
            import(
              /* webpackChunkName: "CareersLocations" */
              '../components/CareersLocations/CareersLocations.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const CareersLocations_styles = loadable(() =>
            import(
              /* webpackChunkName: "CareersLocations.styles" */
              '../components/CareersLocations/CareersLocations.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const CenteredTextVideo = loadable(() =>
            import(
              /* webpackChunkName: "CenteredTextVideo" */
              '../components/CenteredTextVideo/CenteredTextVideo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const CenteredTextVideo_styles = loadable(() =>
            import(
              /* webpackChunkName: "CenteredTextVideo.styles" */
              '../components/CenteredTextVideo/CenteredTextVideo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ConcaveBorder = loadable(() =>
            import(
              /* webpackChunkName: "ConcaveBorder" */
              '../components/ConcaveHero/ConcaveBorder/ConcaveBorder.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ConcaveHero = loadable(() =>
            import(
              /* webpackChunkName: "ConcaveHero" */
              '../components/ConcaveHero/ConcaveHero.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ConcaveHero_styles = loadable(() =>
            import(
              /* webpackChunkName: "ConcaveHero.styles" */
              '../components/ConcaveHero/ConcaveHero.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ContactRepForm = loadable(() =>
            import(
              /* webpackChunkName: "ContactRepForm" */
              '../components/ContactRepForm/ContactRepForm.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ContactRepForm_styles = loadable(() =>
            import(
              /* webpackChunkName: "ContactRepForm.styles" */
              '../components/ContactRepForm/ContactRepForm.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ContactRepHero = loadable(() =>
            import(
              /* webpackChunkName: "ContactRepHero" */
              '../components/ContactRepHero/ContactRepHero.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ContactUsForm = loadable(() =>
            import(
              /* webpackChunkName: "ContactUsForm" */
              '../components/ContactUsForm/ContactUsForm.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ContactUsForm_styles = loadable(() =>
            import(
              /* webpackChunkName: "ContactUsForm.styles" */
              '../components/ContactUsForm/ContactUsForm.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ContactUsHero = loadable(() =>
            import(
              /* webpackChunkName: "ContactUsHero" */
              '../components/ContactUsHero/ContactUsHero.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Content = loadable(() =>
            import(
              /* webpackChunkName: "Content" */
              '../components/Content/Content.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Content_styles = loadable(() =>
            import(
              /* webpackChunkName: "Content.styles" */
              '../components/Content/Content.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ContentBlock = loadable(() =>
            import(
              /* webpackChunkName: "ContentBlock" */
              '../components/ContentBlock/ContentBlock.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ContentBlock_styles = loadable(() =>
            import(
              /* webpackChunkName: "ContentBlock.styles" */
              '../components/ContentBlock/ContentBlock.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ContentCard = loadable(() =>
            import(
              /* webpackChunkName: "ContentCard" */
              '../components/ContentCard/ContentCard.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ContentCard_styles = loadable(() =>
            import(
              /* webpackChunkName: "ContentCard.styles" */
              '../components/ContentCard/ContentCard.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ContentCardContainer = loadable(() =>
            import(
              /* webpackChunkName: "ContentCardContainer" */
              '../components/ContentCardContainer/ContentCardContainer.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ContentCardContainer_styles = loadable(() =>
            import(
              /* webpackChunkName: "ContentCardContainer.styles" */
              '../components/ContentCardContainer/ContentCardContainer.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const CookiePolicy = loadable(() =>
            import(
              /* webpackChunkName: "CookiePolicy" */
              '../components/CookiePolicy/CookiePolicy.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const CookiePolicy_styles = loadable(() =>
            import(
              /* webpackChunkName: "CookiePolicy.styles" */
              '../components/CookiePolicy/CookiePolicy.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const CountdownTimer = loadable(() =>
            import(
              /* webpackChunkName: "CountdownTimer" */
              '../components/CountdownTimer/CountdownTimer.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const CountdownTimer_styles = loadable(() =>
            import(
              /* webpackChunkName: "CountdownTimer.styles" */
              '../components/CountdownTimer/CountdownTimer.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const DualInfoBoxes = loadable(() =>
            import(
              /* webpackChunkName: "DualInfoBoxes" */
              '../components/DualInfoBoxes/DualInfoBoxes.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const DualInfoBoxes_styles = loadable(() =>
            import(
              /* webpackChunkName: "DualInfoBoxes.styles" */
              '../components/DualInfoBoxes/DualInfoBoxes.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FavoritesGrid = loadable(() =>
            import(
              /* webpackChunkName: "FavoritesGrid" */
              '../components/FavoritesGrid/FavoritesGrid.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FavoritesGrid_styles = loadable(() =>
            import(
              /* webpackChunkName: "FavoritesGrid.styles" */
              '../components/FavoritesGrid/FavoritesGrid.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FeaturedDetailHero = loadable(() =>
            import(
              /* webpackChunkName: "FeaturedDetailHero" */
              '../components/FeaturedDetailHero/FeaturedDetailHero.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FeaturedDetailHero_styles = loadable(() =>
            import(
              /* webpackChunkName: "FeaturedDetailHero.styles" */
              '../components/FeaturedDetailHero/FeaturedDetailHero.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ArticlePromo = loadable(() =>
            import(
              /* webpackChunkName: "ArticlePromo" */
              '../components/FeaturedDetailHero/PromoVariants/Article/ArticlePromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ArticlePromo_styles = loadable(() =>
            import(
              /* webpackChunkName: "ArticlePromo.styles" */
              '../components/FeaturedDetailHero/PromoVariants/Article/ArticlePromo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const GeneralPromo = loadable(() =>
            import(
              /* webpackChunkName: "GeneralPromo" */
              '../components/FeaturedDetailHero/PromoVariants/General/GeneralPromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const GeneralPromo_styles = loadable(() =>
            import(
              /* webpackChunkName: "GeneralPromo.styles" */
              '../components/FeaturedDetailHero/PromoVariants/General/GeneralPromo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipePromo = loadable(() =>
            import(
              /* webpackChunkName: "RecipePromo" */
              '../components/FeaturedDetailHero/PromoVariants/Recipe/RecipePromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipePromo_styles = loadable(() =>
            import(
              /* webpackChunkName: "RecipePromo.styles" */
              '../components/FeaturedDetailHero/PromoVariants/Recipe/RecipePromo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const promoVariantColours = loadable(() =>
            import(
              /* webpackChunkName: "promoVariantColours" */
              '../components/FeaturedDetailHero/PromoVariants/promoVariantColours.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FeaturedDetailHeroWithVideo = loadable(() =>
            import(
              /* webpackChunkName: "FeaturedDetailHeroWithVideo" */
              '../components/FeaturedDetailHeroWithVideo/FeaturedDetailHeroWithVideo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FeaturedDetailHeroWithVideo_styles = loadable(() =>
            import(
              /* webpackChunkName: "FeaturedDetailHeroWithVideo.styles" */
              '../components/FeaturedDetailHeroWithVideo/FeaturedDetailHeroWithVideo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FeaturedFacts = loadable(() =>
            import(
              /* webpackChunkName: "FeaturedFacts" */
              '../components/FeaturedFacts/FeaturedFacts.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FeaturedFacts_styles = loadable(() =>
            import(
              /* webpackChunkName: "FeaturedFacts.styles" */
              '../components/FeaturedFacts/FeaturedFacts.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FeaturedRecipePromo = loadable(() =>
            import(
              /* webpackChunkName: "FeaturedRecipePromo" */
              '../components/FeaturedRecipePromo/FeaturedRecipePromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FeaturedRecipePromo_styles = loadable(() =>
            import(
              /* webpackChunkName: "FeaturedRecipePromo.styles" */
              '../components/FeaturedRecipePromo/FeaturedRecipePromo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FindInStoreSearchDestiny = loadable(() =>
            import(
              /* webpackChunkName: "FindInStoreSearchDestiny" */
              '../components/FindInStoreSearchDestiny/FindInStoreSearchDestiny.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FindInStoreSearchDestiny_styles = loadable(() =>
            import(
              /* webpackChunkName: "FindInStoreSearchDestiny.styles" */
              '../components/FindInStoreSearchDestiny/FindInStoreSearchDestiny.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FindNearYou = loadable(() =>
            import(
              /* webpackChunkName: "FindNearYou" */
              '../components/FindNearYou/FindNearYou.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FindNearYou_styles = loadable(() =>
            import(
              /* webpackChunkName: "FindNearYou.styles" */
              '../components/FindNearYou/FindNearYou.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const BottomBorder = loadable(() =>
            import(
              /* webpackChunkName: "BottomBorder" */
              '../components/FlavorHero/BottomBorder/BottomBorder.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FlavorHero = loadable(() =>
            import(
              /* webpackChunkName: "FlavorHero" */
              '../components/FlavorHero/FlavorHero.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FlavorHero_styles = loadable(() =>
            import(
              /* webpackChunkName: "FlavorHero.styles" */
              '../components/FlavorHero/FlavorHero.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SpiralCircle = loadable(() =>
            import(
              /* webpackChunkName: "SpiralCircle" */
              '../components/FlavorHero/SpiralCircle/SpiralCircle.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FlavorIdeaPromo = loadable(() =>
            import(
              /* webpackChunkName: "FlavorIdeaPromo" */
              '../components/FlavorIdeaPromo/FlavorIdeaPromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FlavorIdeaPromo_styles = loadable(() =>
            import(
              /* webpackChunkName: "FlavorIdeaPromo.styles" */
              '../components/FlavorIdeaPromo/FlavorIdeaPromo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FlavorSubmissionForm = loadable(() =>
            import(
              /* webpackChunkName: "FlavorSubmissionForm" */
              '../components/FlavorSubmissionForm/FlavorSubmissionForm.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FlavorSubmissionForm_styles = loadable(() =>
            import(
              /* webpackChunkName: "FlavorSubmissionForm.styles" */
              '../components/FlavorSubmissionForm/FlavorSubmissionForm.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Footer = loadable(() =>
            import(
              /* webpackChunkName: "Footer" */
              '../components/Footer/Footer.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Footer_styles = loadable(() =>
            import(
              /* webpackChunkName: "Footer.styles" */
              '../components/Footer/Footer.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const LinksList = loadable(() =>
            import(
              /* webpackChunkName: "LinksList" */
              '../components/Footer/LinksList/LinksList.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SubscribeLoader = loadable(() =>
            import(
              /* webpackChunkName: "SubscribeLoader" */
              '../components/Footer/SubscribeLoader.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Game = loadable(() =>
            import(
              /* webpackChunkName: "Game" */
              '../components/GameEmbed/Game.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Game_styles = loadable(() =>
            import(
              /* webpackChunkName: "Game.styles" */
              '../components/GameEmbed/Game.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const GameEmbed = loadable(() =>
            import(
              /* webpackChunkName: "GameEmbed" */
              '../components/GameEmbed/GameEmbed.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const GameEmbed_styles = loadable(() =>
            import(
              /* webpackChunkName: "GameEmbed.styles" */
              '../components/GameEmbed/GameEmbed.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Background = loadable(() =>
            import(
              /* webpackChunkName: "Background" */
              '../components/GameEmbed/gridiron/Background.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const GridIron = loadable(() =>
            import(
              /* webpackChunkName: "GridIron" */
              '../components/GameEmbed/gridiron/GridIron.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const GridIron_styles = loadable(() =>
            import(
              /* webpackChunkName: "GridIron.styles" */
              '../components/GameEmbed/gridiron/GridIron.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Obstacle = loadable(() =>
            import(
              /* webpackChunkName: "Obstacle" */
              '../components/GameEmbed/gridiron/Obstacle.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Player = loadable(() =>
            import(
              /* webpackChunkName: "Player" */
              '../components/GameEmbed/gridiron/Player.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const constants = loadable(() =>
            import(
              /* webpackChunkName: "constants" */
              '../components/GameEmbed/gridiron/constants.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const types = loadable(() =>
            import(
              /* webpackChunkName: "types" */
              '../components/GameEmbed/gridiron/types.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const useGameLoop = loadable(() =>
            import(
              /* webpackChunkName: "useGameLoop" */
              '../components/GameEmbed/gridiron/useGameLoop.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const HeroCarousel = loadable(() =>
            import(
              /* webpackChunkName: "HeroCarousel" */
              '../components/HeroCarousel/HeroCarousel.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const HeroCarousel_styles = loadable(() =>
            import(
              /* webpackChunkName: "HeroCarousel.styles" */
              '../components/HeroCarousel/HeroCarousel.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const HeroCarouselSlide = loadable(() =>
            import(
              /* webpackChunkName: "HeroCarouselSlide" */
              '../components/HeroCarouselSlide/HeroCarouselSlide.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const HeroCarouselSlide_styles = loadable(() =>
            import(
              /* webpackChunkName: "HeroCarouselSlide.styles" */
              '../components/HeroCarouselSlide/HeroCarouselSlide.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const HeroButtons = loadable(() =>
            import(
              /* webpackChunkName: "HeroButtons" */
              '../components/HeroWithTextLeft/HeroButtons.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const HeroWithTextLeft = loadable(() =>
            import(
              /* webpackChunkName: "HeroWithTextLeft" */
              '../components/HeroWithTextLeft/HeroWithTextLeft.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const HeroWithTextLeft_styles = loadable(() =>
            import(
              /* webpackChunkName: "HeroWithTextLeft.styles" */
              '../components/HeroWithTextLeft/HeroWithTextLeft.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const clouds = loadable(() =>
            import(
              /* webpackChunkName: "clouds" */
              '../components/HeroWithTextLeft/svg/clouds.jsx'
            ),
            { fallback: <Skeleton /> }
          );
import HomepageHeroCarousel from '../components/HomepageHeroCarousel/HomepageHeroCarousel.jsx';

          const HomepageHeroCarousel_styles = loadable(() =>
            import(
              /* webpackChunkName: "HomepageHeroCarousel.styles" */
              '../components/HomepageHeroCarousel/HomepageHeroCarousel.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const HomepageHeroCarouselSlide = loadable(() =>
            import(
              /* webpackChunkName: "HomepageHeroCarouselSlide" */
              '../components/HomepageHeroCarouselSlide/HomepageHeroCarouselSlide.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const HomepageHeroCarouselSlide_styles = loadable(() =>
            import(
              /* webpackChunkName: "HomepageHeroCarouselSlide.styles" */
              '../components/HomepageHeroCarouselSlide/HomepageHeroCarouselSlide.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const IconButton = loadable(() =>
            import(
              /* webpackChunkName: "IconButton" */
              '../components/IconButton/IconButton.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const IconButton_styles = loadable(() =>
            import(
              /* webpackChunkName: "IconButton.styles" */
              '../components/IconButton/IconButton.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const IconList = loadable(() =>
            import(
              /* webpackChunkName: "IconList" */
              '../components/IconList/IconList.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const IconList_styles = loadable(() =>
            import(
              /* webpackChunkName: "IconList.styles" */
              '../components/IconList/IconList.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const IconListItem = loadable(() =>
            import(
              /* webpackChunkName: "IconListItem" */
              '../components/IconListItem/IconListItem.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ImageCTA = loadable(() =>
            import(
              /* webpackChunkName: "ImageCTA" */
              '../components/ImageCTA/ImageCTA.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ImageComparisonFullWidth = loadable(() =>
            import(
              /* webpackChunkName: "ImageComparisonFullWidth" */
              '../components/ImageComparisonFullWidth/ImageComparisonFullWidth.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ImageComparisonFullWidth_styles = loadable(() =>
            import(
              /* webpackChunkName: "ImageComparisonFullWidth.styles" */
              '../components/ImageComparisonFullWidth/ImageComparisonFullWidth.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ImageSlider = loadable(() =>
            import(
              /* webpackChunkName: "ImageSlider" */
              '../components/ImageSlider/ImageSlider.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ImageSlider_styles = loadable(() =>
            import(
              /* webpackChunkName: "ImageSlider.styles" */
              '../components/ImageSlider/ImageSlider.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ImageSliderAlt = loadable(() =>
            import(
              /* webpackChunkName: "ImageSliderAlt" */
              '../components/ImageSliderAlt/ImageSliderAlt.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ImageSliderAlt_styles = loadable(() =>
            import(
              /* webpackChunkName: "ImageSliderAlt.styles" */
              '../components/ImageSliderAlt/ImageSliderAlt.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ImageSliderSlide = loadable(() =>
            import(
              /* webpackChunkName: "ImageSliderSlide" */
              '../components/ImageSliderSlide/ImageSliderSlide.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ImageSliderSlide_styles = loadable(() =>
            import(
              /* webpackChunkName: "ImageSliderSlide.styles" */
              '../components/ImageSliderSlide/ImageSliderSlide.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ImageWithTextBoxOverlap = loadable(() =>
            import(
              /* webpackChunkName: "ImageWithTextBoxOverlap" */
              '../components/ImageWithTextBoxOverlap/ImageWithTextBoxOverlap.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ImageWithTextBoxOverlap_styles = loadable(() =>
            import(
              /* webpackChunkName: "ImageWithTextBoxOverlap.styles" */
              '../components/ImageWithTextBoxOverlap/ImageWithTextBoxOverlap.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ImageWithTextBoxOverlapItem = loadable(() =>
            import(
              /* webpackChunkName: "ImageWithTextBoxOverlapItem" */
              '../components/ImageWithTextBoxOverlapItem/ImageWithTextBoxOverlapItem.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ImageWithTextBoxOverlapItem_styles = loadable(() =>
            import(
              /* webpackChunkName: "ImageWithTextBoxOverlapItem.styles" */
              '../components/ImageWithTextBoxOverlapItem/ImageWithTextBoxOverlapItem.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const InRecipeProductsFoodservices = loadable(() =>
            import(
              /* webpackChunkName: "InRecipeProductsFoodservices" */
              '../components/InRecipeProductsFoodservices/InRecipeProductsFoodservices.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const InRecipeProductsFoodservices_styles = loadable(() =>
            import(
              /* webpackChunkName: "InRecipeProductsFoodservices.styles" */
              '../components/InRecipeProductsFoodservices/InRecipeProductsFoodservices.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const InRecipeProductsPromo = loadable(() =>
            import(
              /* webpackChunkName: "InRecipeProductsPromo" */
              '../components/InRecipeProductsPromo/InRecipeProductsPromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const InRecipeProductsPromo_styles = loadable(() =>
            import(
              /* webpackChunkName: "InRecipeProductsPromo.styles" */
              '../components/InRecipeProductsPromo/InRecipeProductsPromo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const LandingHero = loadable(() =>
            import(
              /* webpackChunkName: "LandingHero" */
              '../components/LandingHero/LandingHero.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const LandingHero_styles = loadable(() =>
            import(
              /* webpackChunkName: "LandingHero.styles" */
              '../components/LandingHero/LandingHero.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const LazyImage = loadable(() =>
            import(
              /* webpackChunkName: "LazyImage" */
              '../components/LazyImage/LazyImage.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const DesktopNav = loadable(() =>
            import(
              /* webpackChunkName: "DesktopNav" */
              '../components/MainNav/Components/DesktopNav/DesktopNav.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const DesktopNav_styles = loadable(() =>
            import(
              /* webpackChunkName: "DesktopNav.styles" */
              '../components/MainNav/Components/DesktopNav/DesktopNav.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FsDesktopNav = loadable(() =>
            import(
              /* webpackChunkName: "FsDesktopNav" */
              '../components/MainNav/Components/FsDesktopNav/FsDesktopNav.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FsDesktopNav_styles = loadable(() =>
            import(
              /* webpackChunkName: "FsDesktopNav.styles" */
              '../components/MainNav/Components/FsDesktopNav/FsDesktopNav.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FsHamburger = loadable(() =>
            import(
              /* webpackChunkName: "FsHamburger" */
              '../components/MainNav/Components/FsHamburger/FsHamburger.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FsHamburger_styles = loadable(() =>
            import(
              /* webpackChunkName: "FsHamburger.styles" */
              '../components/MainNav/Components/FsHamburger/FsHamburger.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FsMainNavAboutUsLink = loadable(() =>
            import(
              /* webpackChunkName: "FsMainNavAboutUsLink" */
              '../components/MainNav/Components/FsMainNavAboutUsLink/FsMainNavAboutUsLink.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FsMainNavAboutUsLink_styles = loadable(() =>
            import(
              /* webpackChunkName: "FsMainNavAboutUsLink.styles" */
              '../components/MainNav/Components/FsMainNavAboutUsLink/FsMainNavAboutUsLink.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FsMainNavCardLink = loadable(() =>
            import(
              /* webpackChunkName: "FsMainNavCardLink" */
              '../components/MainNav/Components/FsMainNavCardLink/FsMainNavCardLink.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FsMainNavCardLink_styles = loadable(() =>
            import(
              /* webpackChunkName: "FsMainNavCardLink.styles" */
              '../components/MainNav/Components/FsMainNavCardLink/FsMainNavCardLink.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FsMainNavProductLink = loadable(() =>
            import(
              /* webpackChunkName: "FsMainNavProductLink" */
              '../components/MainNav/Components/FsMainNavProductLink/FsMainNavProductLink.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FsMainNavProductLink_styles = loadable(() =>
            import(
              /* webpackChunkName: "FsMainNavProductLink.styles" */
              '../components/MainNav/Components/FsMainNavProductLink/FsMainNavProductLink.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FsMobileNav = loadable(() =>
            import(
              /* webpackChunkName: "FsMobileNav" */
              '../components/MainNav/Components/FsMobileNav/FsMobileNav.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FsMobileNav_styles = loadable(() =>
            import(
              /* webpackChunkName: "FsMobileNav.styles" */
              '../components/MainNav/Components/FsMobileNav/FsMobileNav.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Hamburger = loadable(() =>
            import(
              /* webpackChunkName: "Hamburger" */
              '../components/MainNav/Components/Hamburger/Hamburger.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Hamburger_styles = loadable(() =>
            import(
              /* webpackChunkName: "Hamburger.styles" */
              '../components/MainNav/Components/Hamburger/Hamburger.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const MainNavAboutUsLink = loadable(() =>
            import(
              /* webpackChunkName: "MainNavAboutUsLink" */
              '../components/MainNav/Components/MainNavAboutUsLink/MainNavAboutUsLink.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const MainNavAboutUsLink_styles = loadable(() =>
            import(
              /* webpackChunkName: "MainNavAboutUsLink.styles" */
              '../components/MainNav/Components/MainNavAboutUsLink/MainNavAboutUsLink.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const MainNavProductLink = loadable(() =>
            import(
              /* webpackChunkName: "MainNavProductLink" */
              '../components/MainNav/Components/MainNavProductLink/MainNavProductLink.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const MainNavProductLink_styles = loadable(() =>
            import(
              /* webpackChunkName: "MainNavProductLink.styles" */
              '../components/MainNav/Components/MainNavProductLink/MainNavProductLink.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const MainNavRibbon = loadable(() =>
            import(
              /* webpackChunkName: "MainNavRibbon" */
              '../components/MainNav/Components/MainNavRibbon/MainNavRibbon.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const MainNavRibbon_styles = loadable(() =>
            import(
              /* webpackChunkName: "MainNavRibbon.styles" */
              '../components/MainNav/Components/MainNavRibbon/MainNavRibbon.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const MainNavRibbonCta = loadable(() =>
            import(
              /* webpackChunkName: "MainNavRibbonCta" */
              '../components/MainNav/Components/MainNavRibbonCta/MainNavRibbonCta.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const MainNavRibbonCta_styles = loadable(() =>
            import(
              /* webpackChunkName: "MainNavRibbonCta.styles" */
              '../components/MainNav/Components/MainNavRibbonCta/MainNavRibbonCta.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const MobileNav = loadable(() =>
            import(
              /* webpackChunkName: "MobileNav" */
              '../components/MainNav/Components/MobileNav/MobileNav.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const MobileNav_styles = loadable(() =>
            import(
              /* webpackChunkName: "MobileNav.styles" */
              '../components/MainNav/Components/MobileNav/MobileNav.styles.js'
            ),
            { fallback: <Skeleton /> }
          );
import MainNav from '../components/MainNav/MainNav.jsx';

          const MainNav_styles = loadable(() =>
            import(
              /* webpackChunkName: "MainNav.styles" */
              '../components/MainNav/MainNav.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const MediaCarousel = loadable(() =>
            import(
              /* webpackChunkName: "MediaCarousel" */
              '../components/MediaCarousel/MediaCarousel.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const MediaCarousel_styles = loadable(() =>
            import(
              /* webpackChunkName: "MediaCarousel.styles" */
              '../components/MediaCarousel/MediaCarousel.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const MediaCarouselImageSlide = loadable(() =>
            import(
              /* webpackChunkName: "MediaCarouselImageSlide" */
              '../components/MediaCarouselImageSlide/MediaCarouselImageSlide.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const MediaCarouselImageSlide_styles = loadable(() =>
            import(
              /* webpackChunkName: "MediaCarouselImageSlide.styles" */
              '../components/MediaCarouselImageSlide/MediaCarouselImageSlide.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const MediaCarouselVideoSlide = loadable(() =>
            import(
              /* webpackChunkName: "MediaCarouselVideoSlide" */
              '../components/MediaCarouselVideoSlide/MediaCarouselVideoSlide.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const MediaCarouselVideoSlide_styles = loadable(() =>
            import(
              /* webpackChunkName: "MediaCarouselVideoSlide.styles" */
              '../components/MediaCarouselVideoSlide/MediaCarouselVideoSlide.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const MultiLinkCta = loadable(() =>
            import(
              /* webpackChunkName: "MultiLinkCta" */
              '../components/MultiLinkCta/MultiLinkCta.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const MultiLinkCta_styles = loadable(() =>
            import(
              /* webpackChunkName: "MultiLinkCta.styles" */
              '../components/MultiLinkCta/MultiLinkCta.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const NavLink = loadable(() =>
            import(
              /* webpackChunkName: "NavLink" */
              '../components/NavLink/NavLink.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const NavLink_styles = loadable(() =>
            import(
              /* webpackChunkName: "NavLink.styles" */
              '../components/NavLink/NavLink.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const NotFound = loadable(() =>
            import(
              /* webpackChunkName: "NotFound" */
              '../components/NotFound/NotFound.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const NotFound_styles = loadable(() =>
            import(
              /* webpackChunkName: "NotFound.styles" */
              '../components/NotFound/NotFound.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const NutritionLabelTable = loadable(() =>
            import(
              /* webpackChunkName: "NutritionLabelTable" */
              '../components/NutritionLabelTable.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const OffsetFeaturePromo = loadable(() =>
            import(
              /* webpackChunkName: "OffsetFeaturePromo" */
              '../components/OffsetFeaturePromo/OffsetFeaturePromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const OffsetFeaturePromo_styles = loadable(() =>
            import(
              /* webpackChunkName: "OffsetFeaturePromo.styles" */
              '../components/OffsetFeaturePromo/OffsetFeaturePromo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const OverTheTopSurveyEmbed = loadable(() =>
            import(
              /* webpackChunkName: "OverTheTopSurveyEmbed" */
              '../components/OverTheTopSurveyEmbed/OverTheTopSurveyEmbed.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const OverTheTopSurveyEmbed_styles = loadable(() =>
            import(
              /* webpackChunkName: "OverTheTopSurveyEmbed.styles" */
              '../components/OverTheTopSurveyEmbed/OverTheTopSurveyEmbed.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const PageBanner = loadable(() =>
            import(
              /* webpackChunkName: "PageBanner" */
              '../components/PageBanner/PageBanner.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const PageBanner_styles = loadable(() =>
            import(
              /* webpackChunkName: "PageBanner.styles" */
              '../components/PageBanner/PageBanner.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const PardotSampleRequestForm = loadable(() =>
            import(
              /* webpackChunkName: "PardotSampleRequestForm" */
              '../components/PardotSampleRequestForm/PardotSampleRequestForm.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const PardotSampleRequestForm_styles = loadable(() =>
            import(
              /* webpackChunkName: "PardotSampleRequestForm.styles" */
              '../components/PardotSampleRequestForm/PardotSampleRequestForm.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductCTA = loadable(() =>
            import(
              /* webpackChunkName: "ProductCTA" */
              '../components/ProductCTA/ProductCTA.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductCTA_styles = loadable(() =>
            import(
              /* webpackChunkName: "ProductCTA.styles" */
              '../components/ProductCTA/ProductCTA.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductCanShowcase = loadable(() =>
            import(
              /* webpackChunkName: "ProductCanShowcase" */
              '../components/ProductCanShowcase/ProductCanShowcase.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductDescription = loadable(() =>
            import(
              /* webpackChunkName: "ProductDescription" */
              '../components/ProductDescription/ProductDescription.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductDescription_styles = loadable(() =>
            import(
              /* webpackChunkName: "ProductDescription.styles" */
              '../components/ProductDescription/ProductDescription.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductDetailHero = loadable(() =>
            import(
              /* webpackChunkName: "ProductDetailHero" */
              '../components/ProductDetailHero/ProductDetailHero.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductDetailHero_styles = loadable(() =>
            import(
              /* webpackChunkName: "ProductDetailHero.styles" */
              '../components/ProductDetailHero/ProductDetailHero.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductGrid = loadable(() =>
            import(
              /* webpackChunkName: "ProductGrid" */
              '../components/ProductGrid/ProductGrid.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductGrid_styles = loadable(() =>
            import(
              /* webpackChunkName: "ProductGrid.styles" */
              '../components/ProductGrid/ProductGrid.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductIngredientBenefitsPromo_config = loadable(() =>
            import(
              /* webpackChunkName: "ProductIngredientBenefitsPromo.config" */
              '../components/ProductIngredientBenefitsPromo/ProductIngredientBenefitsPromo.config.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductIngredientBenefitsPromo = loadable(() =>
            import(
              /* webpackChunkName: "ProductIngredientBenefitsPromo" */
              '../components/ProductIngredientBenefitsPromo/ProductIngredientBenefitsPromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductIngredientBenefitsPromo_styles = loadable(() =>
            import(
              /* webpackChunkName: "ProductIngredientBenefitsPromo.styles" */
              '../components/ProductIngredientBenefitsPromo/ProductIngredientBenefitsPromo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductListCarousel = loadable(() =>
            import(
              /* webpackChunkName: "ProductListCarousel" */
              '../components/ProductListCarousel/ProductListCarousel.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductListCarousel_styles = loadable(() =>
            import(
              /* webpackChunkName: "ProductListCarousel.styles" */
              '../components/ProductListCarousel/ProductListCarousel.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductNutritionLabelPromo = loadable(() =>
            import(
              /* webpackChunkName: "ProductNutritionLabelPromo" */
              '../components/ProductNutritionLabelPromo/ProductNutritionLabelPromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductNutritionLabelPromo_styles = loadable(() =>
            import(
              /* webpackChunkName: "ProductNutritionLabelPromo.styles" */
              '../components/ProductNutritionLabelPromo/ProductNutritionLabelPromo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const PromoHero = loadable(() =>
            import(
              /* webpackChunkName: "PromoHero" */
              '../components/PromoHero/PromoHero.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const PromoHero_styles = loadable(() =>
            import(
              /* webpackChunkName: "PromoHero.styles" */
              '../components/PromoHero/PromoHero.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipeDirectionDetails = loadable(() =>
            import(
              /* webpackChunkName: "RecipeDirectionDetails" */
              '../components/RecipeDirectionDetails/RecipeDirectionDetails.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipeDirectionDetails_styles = loadable(() =>
            import(
              /* webpackChunkName: "RecipeDirectionDetails.styles" */
              '../components/RecipeDirectionDetails/RecipeDirectionDetails.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipeGrid = loadable(() =>
            import(
              /* webpackChunkName: "RecipeGrid" */
              '../components/RecipeGrid/RecipeGrid.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipeGrid_styles = loadable(() =>
            import(
              /* webpackChunkName: "RecipeGrid.styles" */
              '../components/RecipeGrid/RecipeGrid.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipeIngredientsDetails = loadable(() =>
            import(
              /* webpackChunkName: "RecipeIngredientsDetails" */
              '../components/RecipeIngredientsDetails/RecipeIngredientsDetails.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipeIngredientsDetails_styles = loadable(() =>
            import(
              /* webpackChunkName: "RecipeIngredientsDetails.styles" */
              '../components/RecipeIngredientsDetails/RecipeIngredientsDetails.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipeOverview = loadable(() =>
            import(
              /* webpackChunkName: "RecipeOverview" */
              '../components/RecipeOverview/RecipeOverview.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipeOverview_styles = loadable(() =>
            import(
              /* webpackChunkName: "RecipeOverview.styles" */
              '../components/RecipeOverview/RecipeOverview.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipeOverviewDirect = loadable(() =>
            import(
              /* webpackChunkName: "RecipeOverviewDirect" */
              '../components/RecipeOverview/RecipeOverviewDirect.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RecommendRecipe = loadable(() =>
            import(
              /* webpackChunkName: "RecommendRecipe" */
              '../components/RecommendRecipe/RecommendRecipe.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RecommendRecipe_styles = loadable(() =>
            import(
              /* webpackChunkName: "RecommendRecipe.styles" */
              '../components/RecommendRecipe/RecommendRecipe.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const RelatedCarousel = loadable(() =>
            import(
              /* webpackChunkName: "RelatedCarousel" */
              '../components/RelatedCarousel/RelatedCarousel.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RelatedCarousel_styles = loadable(() =>
            import(
              /* webpackChunkName: "RelatedCarousel.styles" */
              '../components/RelatedCarousel/RelatedCarousel.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const RelatedCarouselSlide = loadable(() =>
            import(
              /* webpackChunkName: "RelatedCarouselSlide" */
              '../components/RelatedCarouselSlide/RelatedCarouselSlide.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RelatedCarouselSlide_styles = loadable(() =>
            import(
              /* webpackChunkName: "RelatedCarouselSlide.styles" */
              '../components/RelatedCarouselSlide/RelatedCarouselSlide.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const RelatedPagesGrid = loadable(() =>
            import(
              /* webpackChunkName: "RelatedPagesGrid" */
              '../components/RelatedPagesGrid/RelatedPagesGrid.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RelatedPagesGrid_styles = loadable(() =>
            import(
              /* webpackChunkName: "RelatedPagesGrid.styles" */
              '../components/RelatedPagesGrid/RelatedPagesGrid.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const RelatedPagesPromo = loadable(() =>
            import(
              /* webpackChunkName: "RelatedPagesPromo" */
              '../components/RelatedPagesPromo/RelatedPagesPromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RelatedPagesPromo_styles = loadable(() =>
            import(
              /* webpackChunkName: "RelatedPagesPromo.styles" */
              '../components/RelatedPagesPromo/RelatedPagesPromo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const AltPromo = loadable(() =>
            import(
              /* webpackChunkName: "AltPromo" */
              '../components/RelatedPagesPromo/SubTemplates/AltPromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const BeanBqPromo = loadable(() =>
            import(
              /* webpackChunkName: "BeanBqPromo" */
              '../components/RelatedPagesPromo/SubTemplates/BeanBqPromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const BlueyPromo = loadable(() =>
            import(
              /* webpackChunkName: "BlueyPromo" */
              '../components/RelatedPagesPromo/SubTemplates/BlueyPromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const DefaultPromo = loadable(() =>
            import(
              /* webpackChunkName: "DefaultPromo" */
              '../components/RelatedPagesPromo/SubTemplates/DefaultPromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FeaturedPromo = loadable(() =>
            import(
              /* webpackChunkName: "FeaturedPromo" */
              '../components/RelatedPagesPromo/SubTemplates/FeaturedPromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FoodservicesPromo = loadable(() =>
            import(
              /* webpackChunkName: "FoodservicesPromo" */
              '../components/RelatedPagesPromo/SubTemplates/FoodservicesPromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const LandingSurveyPromo = loadable(() =>
            import(
              /* webpackChunkName: "LandingSurveyPromo" */
              '../components/RelatedPagesPromo/SubTemplates/LandingSurveyPromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const cardShapeData = loadable(() =>
            import(
              /* webpackChunkName: "cardShapeData" */
              '../components/RelatedPagesPromo/SubTemplates/cardShapeData.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ScrollingImagesPromo = loadable(() =>
            import(
              /* webpackChunkName: "ScrollingImagesPromo" */
              '../components/ScrollingImagesPromo/ScrollingImagesPromo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ScrollingImagesPromo_styles = loadable(() =>
            import(
              /* webpackChunkName: "ScrollingImagesPromo.styles" */
              '../components/ScrollingImagesPromo/ScrollingImagesPromo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ScrollingImagesPromoSlide = loadable(() =>
            import(
              /* webpackChunkName: "ScrollingImagesPromoSlide" */
              '../components/ScrollingImagesPromoSlide/ScrollingImagesPromoSlide.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ScrollingImagesPromoSlide_styles = loadable(() =>
            import(
              /* webpackChunkName: "ScrollingImagesPromoSlide.styles" */
              '../components/ScrollingImagesPromoSlide/ScrollingImagesPromoSlide.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ScrollingVanityTextWithVideo = loadable(() =>
            import(
              /* webpackChunkName: "ScrollingVanityTextWithVideo" */
              '../components/ScrollingVanityTextWithVideo/ScrollingVanityTextWithVideo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ScrollingVanityTextWithVideo_styles = loadable(() =>
            import(
              /* webpackChunkName: "ScrollingVanityTextWithVideo.styles" */
              '../components/ScrollingVanityTextWithVideo/ScrollingVanityTextWithVideo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SearchBox = loadable(() =>
            import(
              /* webpackChunkName: "SearchBox" */
              '../components/SearchBox/SearchBox.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SearchBox_styles = loadable(() =>
            import(
              /* webpackChunkName: "SearchBox.styles" */
              '../components/SearchBox/SearchBox.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const BeanSurprise = loadable(() =>
            import(
              /* webpackChunkName: "BeanSurprise" */
              '../components/SideBySide/BeanSurprise/BeanSurprise.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SideBySide = loadable(() =>
            import(
              /* webpackChunkName: "SideBySide" */
              '../components/SideBySide/SideBySide.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SideBySide_styles = loadable(() =>
            import(
              /* webpackChunkName: "SideBySide.styles" */
              '../components/SideBySide/SideBySide.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SideBySideLargeImage = loadable(() =>
            import(
              /* webpackChunkName: "SideBySideLargeImage" */
              '../components/SideBySideLargeImage/SideBySideLargeImage.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SideBySideLargeImage_styles = loadable(() =>
            import(
              /* webpackChunkName: "SideBySideLargeImage.styles" */
              '../components/SideBySideLargeImage/SideBySideLargeImage.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const HandleSvg = loadable(() =>
            import(
              /* webpackChunkName: "HandleSvg" */
              '../components/SideBySideRevealImage/InlineSvg/HandleSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SideBySideRevealImage = loadable(() =>
            import(
              /* webpackChunkName: "SideBySideRevealImage" */
              '../components/SideBySideRevealImage/SideBySideRevealImage.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SideBySideRevealImage_styles = loadable(() =>
            import(
              /* webpackChunkName: "SideBySideRevealImage.styles" */
              '../components/SideBySideRevealImage/SideBySideRevealImage.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SideBySideVideo = loadable(() =>
            import(
              /* webpackChunkName: "SideBySideVideo" */
              '../components/SideBySideVideo/SideBySideVideo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SideBySideVideo_styles = loadable(() =>
            import(
              /* webpackChunkName: "SideBySideVideo.styles" */
              '../components/SideBySideVideo/SideBySideVideo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SingleCenteredVideo = loadable(() =>
            import(
              /* webpackChunkName: "SingleCenteredVideo" */
              '../components/SingleCenteredVideo/SingleCenteredVideo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SingleCenteredVideo_styles = loadable(() =>
            import(
              /* webpackChunkName: "SingleCenteredVideo.styles" */
              '../components/SingleCenteredVideo/SingleCenteredVideo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SiteSearchResults = loadable(() =>
            import(
              /* webpackChunkName: "SiteSearchResults" */
              '../components/SiteSearchResults/SiteSearchResults.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SiteSearchResults_styles = loadable(() =>
            import(
              /* webpackChunkName: "SiteSearchResults.styles" */
              '../components/SiteSearchResults/SiteSearchResults.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SmallImageWithText = loadable(() =>
            import(
              /* webpackChunkName: "SmallImageWithText" */
              '../components/SmallImageWithText/SmallImageWithText.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SmallImageWithText_styles = loadable(() =>
            import(
              /* webpackChunkName: "SmallImageWithText.styles" */
              '../components/SmallImageWithText/SmallImageWithText.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SmallSideBySide = loadable(() =>
            import(
              /* webpackChunkName: "SmallSideBySide" */
              '../components/SmallSideBySide/SmallSideBySide.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SmallSideBySide_styles = loadable(() =>
            import(
              /* webpackChunkName: "SmallSideBySide.styles" */
              '../components/SmallSideBySide/SmallSideBySide.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SocialShare = loadable(() =>
            import(
              /* webpackChunkName: "SocialShare" */
              '../components/SocialShare/SocialShare.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SocialShare_styles = loadable(() =>
            import(
              /* webpackChunkName: "SocialShare.styles" */
              '../components/SocialShare/SocialShare.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SocialVideo = loadable(() =>
            import(
              /* webpackChunkName: "SocialVideo" */
              '../components/SocialVideo/SocialVideo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SocialVideo_styles = loadable(() =>
            import(
              /* webpackChunkName: "SocialVideo.styles" */
              '../components/SocialVideo/SocialVideo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const VerticalLineDecorationSvg = loadable(() =>
            import(
              /* webpackChunkName: "VerticalLineDecorationSvg" */
              '../components/SocialVideo/VerticalLineDecorationSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SocialVideoSlide = loadable(() =>
            import(
              /* webpackChunkName: "SocialVideoSlide" */
              '../components/SocialVideoSlide/SocialVideoSlide.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SocialVideoSlide_styles = loadable(() =>
            import(
              /* webpackChunkName: "SocialVideoSlide.styles" */
              '../components/SocialVideoSlide/SocialVideoSlide.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const CirclePlayBtnSvg = loadable(() =>
            import(
              /* webpackChunkName: "CirclePlayBtnSvg" */
              '../components/SocialVideoSlide/SubTemplates/CirclePlayBtnSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SustainabilityFeatureCards = loadable(() =>
            import(
              /* webpackChunkName: "SustainabilityFeatureCards" */
              '../components/SustainabilityFeatureCards/SustainabilityFeatureCards.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SustainabilitySlider = loadable(() =>
            import(
              /* webpackChunkName: "SustainabilitySlider" */
              '../components/SustainabilitySlider/SustainabilitySlider.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SustainabilityStats = loadable(() =>
            import(
              /* webpackChunkName: "SustainabilityStats" */
              '../components/SustainabilityStats/SustainabilityStats.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SustainabilityVideoHero = loadable(() =>
            import(
              /* webpackChunkName: "SustainabilityVideoHero" */
              '../components/SustainabilityVideoHero/SustainabilityVideoHero.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const NutritionLabelTableCA = loadable(() =>
            import(
              /* webpackChunkName: "NutritionLabelTableCA" */
              '../components/Tables/CA/NutritionLabelTableCA.js'
            ),
            { fallback: <Skeleton /> }
          );

          const NutritionLabelTableCA_styles = loadable(() =>
            import(
              /* webpackChunkName: "NutritionLabelTableCA.styles" */
              '../components/Tables/CA/NutritionLabelTableCA.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const NutritionLabelTableUS = loadable(() =>
            import(
              /* webpackChunkName: "NutritionLabelTableUS" */
              '../components/Tables/US/NutritionLabelTableUS.js'
            ),
            { fallback: <Skeleton /> }
          );

          const NutritionLabelTableUS_styles = loadable(() =>
            import(
              /* webpackChunkName: "NutritionLabelTableUS.styles" */
              '../components/Tables/US/NutritionLabelTableUS.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const TestComponent = loadable(() =>
            import(
              /* webpackChunkName: "TestComponent" */
              '../components/TestComponent.js'
            ),
            { fallback: <Skeleton /> }
          );

          const TestimonialCarousel = loadable(() =>
            import(
              /* webpackChunkName: "TestimonialCarousel" */
              '../components/TestimonialCarousel/TestimonialCarousel.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const TestimonialCarousel_styles = loadable(() =>
            import(
              /* webpackChunkName: "TestimonialCarousel.styles" */
              '../components/TestimonialCarousel/TestimonialCarousel.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const TestimonialCarouselSlide = loadable(() =>
            import(
              /* webpackChunkName: "TestimonialCarouselSlide" */
              '../components/TestimonialCarouselSlide/TestimonialCarouselSlide.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const TestimonialCarouselSlide_styles = loadable(() =>
            import(
              /* webpackChunkName: "TestimonialCarouselSlide.styles" */
              '../components/TestimonialCarouselSlide/TestimonialCarouselSlide.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const AlchemerSurvey = loadable(() =>
            import(
              /* webpackChunkName: "AlchemerSurvey" */
              '../components/Text/SubTemplates/AlchemerSurvey.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const AlchemerSurvey_styles = loadable(() =>
            import(
              /* webpackChunkName: "AlchemerSurvey.styles" */
              '../components/Text/SubTemplates/AlchemerSurvey.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const AlchemerSurveyIframe = loadable(() =>
            import(
              /* webpackChunkName: "AlchemerSurveyIframe" */
              '../components/Text/SubTemplates/AlchemerSurveyIframe.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const AlchemerSurveyOnPage = loadable(() =>
            import(
              /* webpackChunkName: "AlchemerSurveyOnPage" */
              '../components/Text/SubTemplates/AlchemerSurveyOnPage.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const BeanGameComponent = loadable(() =>
            import(
              /* webpackChunkName: "BeanGameComponent" */
              '../components/Text/SubTemplates/BeanGameComponent.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const BeanGameComponent_styles = loadable(() =>
            import(
              /* webpackChunkName: "BeanGameComponent.styles" */
              '../components/Text/SubTemplates/BeanGameComponent.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const CenteredVideo = loadable(() =>
            import(
              /* webpackChunkName: "CenteredVideo" */
              '../components/Text/SubTemplates/CenteredVideo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const CenteredVideo_styles = loadable(() =>
            import(
              /* webpackChunkName: "CenteredVideo.styles" */
              '../components/Text/SubTemplates/CenteredVideo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const CenteredVideoComponent = loadable(() =>
            import(
              /* webpackChunkName: "CenteredVideoComponent" */
              '../components/Text/SubTemplates/CenteredVideoComponent.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const CenteredVideoComponent_styles = loadable(() =>
            import(
              /* webpackChunkName: "CenteredVideoComponent.styles" */
              '../components/Text/SubTemplates/CenteredVideoComponent.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const BeanAndBurst = loadable(() =>
            import(
              /* webpackChunkName: "BeanAndBurst" */
              '../components/Text/SubTemplates/InlineSvg/BeanAndBurst.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const DukeBlueBean = loadable(() =>
            import(
              /* webpackChunkName: "DukeBlueBean" */
              '../components/Text/SubTemplates/InlineSvg/DukeBlueBean.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const DukeInBeanSvg = loadable(() =>
            import(
              /* webpackChunkName: "DukeInBeanSvg" */
              '../components/Text/SubTemplates/InlineSvg/DukeInBeanSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const DukeInBeanSvg_styles = loadable(() =>
            import(
              /* webpackChunkName: "DukeInBeanSvg.styles" */
              '../components/Text/SubTemplates/InlineSvg/DukeInBeanSvg.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const DukeTalkBubbleSmallSvg = loadable(() =>
            import(
              /* webpackChunkName: "DukeTalkBubbleSmallSvg" */
              '../components/Text/SubTemplates/InlineSvg/DukeTalkBubbleSmallSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const DukeTalkBubbleSvg = loadable(() =>
            import(
              /* webpackChunkName: "DukeTalkBubbleSvg" */
              '../components/Text/SubTemplates/InlineSvg/DukeTalkBubbleSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const JayDukeSecretFamilyRecipeSvg = loadable(() =>
            import(
              /* webpackChunkName: "JayDukeSecretFamilyRecipeSvg" */
              '../components/Text/SubTemplates/InlineSvg/JayDukeSecretFamilyRecipeSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const JayDukeSecretFamilyRecipeSvg_style = loadable(() =>
            import(
              /* webpackChunkName: "JayDukeSecretFamilyRecipeSvg.style" */
              '../components/Text/SubTemplates/InlineSvg/JayDukeSecretFamilyRecipeSvg.style.js'
            ),
            { fallback: <Skeleton /> }
          );

          const NineteenNfourSvg = loadable(() =>
            import(
              /* webpackChunkName: "NineteenNfourSvg" */
              '../components/Text/SubTemplates/InlineSvg/NineteenNfourSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const NineteenNfourSvg_styles = loadable(() =>
            import(
              /* webpackChunkName: "NineteenNfourSvg.styles" */
              '../components/Text/SubTemplates/InlineSvg/NineteenNfourSvg.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const PlayBtnSvg = loadable(() =>
            import(
              /* webpackChunkName: "PlayBtnSvg" */
              '../components/Text/SubTemplates/InlineSvg/PlayBtnSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const PlayCutOutSvg = loadable(() =>
            import(
              /* webpackChunkName: "PlayCutOutSvg" */
              '../components/Text/SubTemplates/InlineSvg/PlayCutOutSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SoDarnGoodBBLogoSvg = loadable(() =>
            import(
              /* webpackChunkName: "SoDarnGoodBBLogoSvg" */
              '../components/Text/SubTemplates/InlineSvg/SoDarnGoodBBLogoSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SoDarnGoodBBLogoSvg_styles = loadable(() =>
            import(
              /* webpackChunkName: "SoDarnGoodBBLogoSvg.styles" */
              '../components/Text/SubTemplates/InlineSvg/SoDarnGoodBBLogoSvg.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SoDarnGoodCSvg = loadable(() =>
            import(
              /* webpackChunkName: "SoDarnGoodCSvg" */
              '../components/Text/SubTemplates/InlineSvg/SoDarnGoodCSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SoDarnGoodCSvg_styles = loadable(() =>
            import(
              /* webpackChunkName: "SoDarnGoodCSvg.styles" */
              '../components/Text/SubTemplates/InlineSvg/SoDarnGoodCSvg.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SoDarnGoodCirclePlateSvg = loadable(() =>
            import(
              /* webpackChunkName: "SoDarnGoodCirclePlateSvg" */
              '../components/Text/SubTemplates/InlineSvg/SoDarnGoodCirclePlateSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SoDarnGoodESvg = loadable(() =>
            import(
              /* webpackChunkName: "SoDarnGoodESvg" */
              '../components/Text/SubTemplates/InlineSvg/SoDarnGoodESvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SoDarnGoodESvg_styles = loadable(() =>
            import(
              /* webpackChunkName: "SoDarnGoodESvg.styles" */
              '../components/Text/SubTemplates/InlineSvg/SoDarnGoodESvg.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ThirtyKSvg = loadable(() =>
            import(
              /* webpackChunkName: "ThirtyKSvg" */
              '../components/Text/SubTemplates/InlineSvg/ThirtyKSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ThirtyKSvg_styles = loadable(() =>
            import(
              /* webpackChunkName: "ThirtyKSvg.styles" */
              '../components/Text/SubTemplates/InlineSvg/ThirtyKSvg.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const MinesweeperIframe = loadable(() =>
            import(
              /* webpackChunkName: "MinesweeperIframe" */
              '../components/Text/SubTemplates/MinesweeperIframe.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const NewsletterFormComponent = loadable(() =>
            import(
              /* webpackChunkName: "NewsletterFormComponent" */
              '../components/Text/SubTemplates/NewsletterFormComponent.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const OverTheTopIframe = loadable(() =>
            import(
              /* webpackChunkName: "OverTheTopIframe" */
              '../components/Text/SubTemplates/OverTheTopIframe.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const OverTheTopSurvey = loadable(() =>
            import(
              /* webpackChunkName: "OverTheTopSurvey" */
              '../components/Text/SubTemplates/OverTheTopSurvey.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const OverTheTopSurvey_styles = loadable(() =>
            import(
              /* webpackChunkName: "OverTheTopSurvey.styles" */
              '../components/Text/SubTemplates/OverTheTopSurvey.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SampleRequestForm = loadable(() =>
            import(
              /* webpackChunkName: "SampleRequestForm" */
              '../components/Text/SubTemplates/SampleRequestForm.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SampleRequestForm_styles = loadable(() =>
            import(
              /* webpackChunkName: "SampleRequestForm.styles" */
              '../components/Text/SubTemplates/SampleRequestForm.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SocialMediaComponent = loadable(() =>
            import(
              /* webpackChunkName: "SocialMediaComponent" */
              '../components/Text/SubTemplates/SocialMediaComponent.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SocialMediaComponent_styles = loadable(() =>
            import(
              /* webpackChunkName: "SocialMediaComponent.styles" */
              '../components/Text/SubTemplates/SocialMediaComponent.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const UpdBeanGameComponent = loadable(() =>
            import(
              /* webpackChunkName: "UpdBeanGameComponent" */
              '../components/Text/SubTemplates/UpdBeanGameComponent.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const VideoPlayer = loadable(() =>
            import(
              /* webpackChunkName: "VideoPlayer" */
              '../components/Text/SubTemplates/VideoPlayer.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const VideoRightComponent = loadable(() =>
            import(
              /* webpackChunkName: "VideoRightComponent" */
              '../components/Text/SubTemplates/VideoRightComponent.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const VideoRightComponent_styles = loadable(() =>
            import(
              /* webpackChunkName: "VideoRightComponent.styles" */
              '../components/Text/SubTemplates/VideoRightComponent.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const VideoTimelineComponent = loadable(() =>
            import(
              /* webpackChunkName: "VideoTimelineComponent" */
              '../components/Text/SubTemplates/VideoTimelineComponent.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const VideoTimelineComponent_styles = loadable(() =>
            import(
              /* webpackChunkName: "VideoTimelineComponent.styles" */
              '../components/Text/SubTemplates/VideoTimelineComponent.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const VideoTimelineYoutubePlayer = loadable(() =>
            import(
              /* webpackChunkName: "VideoTimelineYoutubePlayer" */
              '../components/Text/SubTemplates/VideoTimelineYoutubePlayer.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const YouMadeIt = loadable(() =>
            import(
              /* webpackChunkName: "YouMadeIt" */
              '../components/Text/SubTemplates/YouMadeIt.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Text = loadable(() =>
            import(
              /* webpackChunkName: "Text" */
              '../components/Text/Text.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Text_styles = loadable(() =>
            import(
              /* webpackChunkName: "Text.styles" */
              '../components/Text/Text.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const TextDualImage = loadable(() =>
            import(
              /* webpackChunkName: "TextDualImage" */
              '../components/TextDualImage/TextDualImage.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const TextDualImage_styles = loadable(() =>
            import(
              /* webpackChunkName: "TextDualImage.styles" */
              '../components/TextDualImage/TextDualImage.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const TextImageSwap = loadable(() =>
            import(
              /* webpackChunkName: "TextImageSwap" */
              '../components/TextImageSwap/TextImageSwap.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const TextImageSwap_styles = loadable(() =>
            import(
              /* webpackChunkName: "TextImageSwap.styles" */
              '../components/TextImageSwap/TextImageSwap.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SvgSmileyTBBC = loadable(() =>
            import(
              /* webpackChunkName: "SvgSmileyTBBC" */
              '../components/TextImageSwap/svg/SvgSmileyTBBC.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const TextLeftFramedVideoRight = loadable(() =>
            import(
              /* webpackChunkName: "TextLeftFramedVideoRight" */
              '../components/TextLeftFramedVideoRight/TextLeftFramedVideoRight.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const TextLeftFramedVideoRight_styles = loadable(() =>
            import(
              /* webpackChunkName: "TextLeftFramedVideoRight.styles" */
              '../components/TextLeftFramedVideoRight/TextLeftFramedVideoRight.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const TextLeftVideoRight = loadable(() =>
            import(
              /* webpackChunkName: "TextLeftVideoRight" */
              '../components/TextLeftVideoRight/TextLeftVideoRight.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const TextLeftVideoRight_styles = loadable(() =>
            import(
              /* webpackChunkName: "TextLeftVideoRight.styles" */
              '../components/TextLeftVideoRight/TextLeftVideoRight.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const TextWithImages = loadable(() =>
            import(
              /* webpackChunkName: "TextWithImages" */
              '../components/TextWithImages/TextWithImages.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const TextWithImages_styles = loadable(() =>
            import(
              /* webpackChunkName: "TextWithImages.styles" */
              '../components/TextWithImages/TextWithImages.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ThirtyYearsSvg = loadable(() =>
            import(
              /* webpackChunkName: "ThirtyYearsSvg" */
              '../components/ThirtyYearsSvg/ThirtyYearsSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ThirtyYearsSvg_styles = loadable(() =>
            import(
              /* webpackChunkName: "ThirtyYearsSvg.styles" */
              '../components/ThirtyYearsSvg/ThirtyYearsSvg.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ThreeColShowcase = loadable(() =>
            import(
              /* webpackChunkName: "ThreeColShowcase" */
              '../components/ThreeColShowcase/ThreeColShowcase.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ThreeColShowcase_styles = loadable(() =>
            import(
              /* webpackChunkName: "ThreeColShowcase.styles" */
              '../components/ThreeColShowcase/ThreeColShowcase.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ThreeColumnSingleImage = loadable(() =>
            import(
              /* webpackChunkName: "ThreeColumnSingleImage" */
              '../components/ThreeColumnSingleImage/ThreeColumnSingleImage.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ThreeColumnSingleImage_styles = loadable(() =>
            import(
              /* webpackChunkName: "ThreeColumnSingleImage.styles" */
              '../components/ThreeColumnSingleImage/ThreeColumnSingleImage.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const TvVideoFrame = loadable(() =>
            import(
              /* webpackChunkName: "TvVideoFrame" */
              '../components/TvVideoFrame/TvVideoFrame.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const TvVideoFrame_styles = loadable(() =>
            import(
              /* webpackChunkName: "TvVideoFrame.styles" */
              '../components/TvVideoFrame/TvVideoFrame.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const UtilityNav = loadable(() =>
            import(
              /* webpackChunkName: "UtilityNav" */
              '../components/UtilityNav/UtilityNav.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const VendorForm = loadable(() =>
            import(
              /* webpackChunkName: "VendorForm" */
              '../components/VendorForm/VendorForm.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const VendorForm_styles = loadable(() =>
            import(
              /* webpackChunkName: "VendorForm.styles" */
              '../components/VendorForm/VendorForm.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const VersusModule = loadable(() =>
            import(
              /* webpackChunkName: "VersusModule" */
              '../components/VersusModule/VersusModule.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const VersusModule_styles = loadable(() =>
            import(
              /* webpackChunkName: "VersusModule.styles" */
              '../components/VersusModule/VersusModule.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const CircularPlayBtnSvg = loadable(() =>
            import(
              /* webpackChunkName: "CircularPlayBtnSvg" */
              '../components/VerticalEmbeds/SubTemplates/CircularPlayBtnSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const LookAndFind = loadable(() =>
            import(
              /* webpackChunkName: "LookAndFind" */
              '../components/VerticalEmbeds/SubTemplates/LookAndFind.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const LookAndFind_styles = loadable(() =>
            import(
              /* webpackChunkName: "LookAndFind.styles" */
              '../components/VerticalEmbeds/SubTemplates/LookAndFind.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const VerticalEmbedsVideo = loadable(() =>
            import(
              /* webpackChunkName: "VerticalEmbedsVideo" */
              '../components/VerticalEmbeds/SubTemplates/VerticalEmbedsVideo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const VerticalEmbedsVideo_styles = loadable(() =>
            import(
              /* webpackChunkName: "VerticalEmbedsVideo.styles" */
              '../components/VerticalEmbeds/SubTemplates/VerticalEmbedsVideo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const YoutubePlayerWindow = loadable(() =>
            import(
              /* webpackChunkName: "YoutubePlayerWindow" */
              '../components/VerticalEmbeds/SubTemplates/YoutubePlayerWindow.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const VerticalEmbeds = loadable(() =>
            import(
              /* webpackChunkName: "VerticalEmbeds" */
              '../components/VerticalEmbeds/VerticalEmbeds.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const VerticalEmbeds_styles = loadable(() =>
            import(
              /* webpackChunkName: "VerticalEmbeds.styles" */
              '../components/VerticalEmbeds/VerticalEmbeds.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const VimeoVideo = loadable(() =>
            import(
              /* webpackChunkName: "VimeoVideo" */
              '../components/VimeoVideo/VimeoVideo.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const VimeoVideo_styles = loadable(() =>
            import(
              /* webpackChunkName: "VimeoVideo.styles" */
              '../components/VimeoVideo/VimeoVideo.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const VisitorCenterHours = loadable(() =>
            import(
              /* webpackChunkName: "VisitorCenterHours" */
              '../components/VisitorCenterHours/VisitorCenterHours.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const VisitorCenterHours_styles = loadable(() =>
            import(
              /* webpackChunkName: "VisitorCenterHours.styles" */
              '../components/VisitorCenterHours/VisitorCenterHours.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const YoutubePlayer = loadable(() =>
            import(
              /* webpackChunkName: "YoutubePlayer" */
              '../components/YoutubePlayer.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_FieldUsage_Checkbox = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-FieldUsage-Checkbox" */
              '../components/fields/Styleguide-FieldUsage-Checkbox.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_FieldUsage_ContentList = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-FieldUsage-ContentList" */
              '../components/fields/Styleguide-FieldUsage-ContentList.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_FieldUsage_Custom = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-FieldUsage-Custom" */
              '../components/fields/Styleguide-FieldUsage-Custom.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_FieldUsage_Date = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-FieldUsage-Date" */
              '../components/fields/Styleguide-FieldUsage-Date.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_FieldUsage_File = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-FieldUsage-File" */
              '../components/fields/Styleguide-FieldUsage-File.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_FieldUsage_Image = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-FieldUsage-Image" */
              '../components/fields/Styleguide-FieldUsage-Image.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_FieldUsage_ItemLink = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-FieldUsage-ItemLink" */
              '../components/fields/Styleguide-FieldUsage-ItemLink.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_FieldUsage_Link = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-FieldUsage-Link" */
              '../components/fields/Styleguide-FieldUsage-Link.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_FieldUsage_Number = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-FieldUsage-Number" */
              '../components/fields/Styleguide-FieldUsage-Number.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_FieldUsage_RichText = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-FieldUsage-RichText" */
              '../components/fields/Styleguide-FieldUsage-RichText.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_FieldUsage_Text = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-FieldUsage-Text" */
              '../components/fields/Styleguide-FieldUsage-Text.js'
            ),
            { fallback: <Skeleton /> }
          );

          const GraphQL_ConnectedDemo = loadable(() =>
            import(
              /* webpackChunkName: "GraphQL-ConnectedDemo" */
              '../components/graphql/GraphQL-ConnectedDemo.js'
            ),
            { fallback: <Skeleton /> }
          );

          const GraphQL_IntegratedDemo = loadable(() =>
            import(
              /* webpackChunkName: "GraphQL-IntegratedDemo" */
              '../components/graphql/GraphQL-IntegratedDemo.js'
            ),
            { fallback: <Skeleton /> }
          );

          const GraphQL_Layout = loadable(() =>
            import(
              /* webpackChunkName: "GraphQL-Layout" */
              '../components/graphql/GraphQL-Layout.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Button = loadable(() =>
            import(
              /* webpackChunkName: "Button" */
              '../components/shared/Button/Button.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Button_styles = loadable(() =>
            import(
              /* webpackChunkName: "Button.styles" */
              '../components/shared/Button/Button.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ButtonTypes = loadable(() =>
            import(
              /* webpackChunkName: "ButtonTypes" */
              '../components/shared/Button/ButtonTypes.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Card = loadable(() =>
            import(
              /* webpackChunkName: "Card" */
              '../components/shared/Card/Card.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Card_styles = loadable(() =>
            import(
              /* webpackChunkName: "Card.styles" */
              '../components/shared/Card/Card.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const CardTypes = loadable(() =>
            import(
              /* webpackChunkName: "CardTypes" */
              '../components/shared/Card/CardTypes/CardTypes.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const CardTypes_styles = loadable(() =>
            import(
              /* webpackChunkName: "CardTypes.styles" */
              '../components/shared/Card/CardTypes/CardTypes.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ArticleCard = loadable(() =>
            import(
              /* webpackChunkName: "ArticleCard" */
              '../components/shared/Card/CardTypes/article/ArticleCard.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const CardTypeContentCard = loadable(() =>
            import(
              /* webpackChunkName: "CardTypeContentCard" */
              '../components/shared/Card/CardTypes/content/CardTypeContentCard.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FeaturedCard = loadable(() =>
            import(
              /* webpackChunkName: "FeaturedCard" */
              '../components/shared/Card/CardTypes/featured/FeaturedCard.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const PageCard = loadable(() =>
            import(
              /* webpackChunkName: "PageCard" */
              '../components/shared/Card/CardTypes/page/PageCard.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductCard = loadable(() =>
            import(
              /* webpackChunkName: "ProductCard" */
              '../components/shared/Card/CardTypes/product/ProductCard.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductPromoCard = loadable(() =>
            import(
              /* webpackChunkName: "ProductPromoCard" */
              '../components/shared/Card/CardTypes/product/ProductPromoCard.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipeCard = loadable(() =>
            import(
              /* webpackChunkName: "RecipeCard" */
              '../components/shared/Card/CardTypes/recipe/RecipeCard.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipePromoCard = loadable(() =>
            import(
              /* webpackChunkName: "RecipePromoCard" */
              '../components/shared/Card/CardTypes/recipe/RecipePromoCard.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RelatedCard = loadable(() =>
            import(
              /* webpackChunkName: "RelatedCard" */
              '../components/shared/Card/CardTypes/related/RelatedCard.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RelatedAltCard = loadable(() =>
            import(
              /* webpackChunkName: "RelatedAltCard" */
              '../components/shared/Card/CardTypes/relatedAlt/RelatedAltCard.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const CardFs = loadable(() =>
            import(
              /* webpackChunkName: "CardFs" */
              '../components/shared/CardFs/CardFs.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const CardFs_styles = loadable(() =>
            import(
              /* webpackChunkName: "CardFs.styles" */
              '../components/shared/CardFs/CardFs.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const CardTypesFs = loadable(() =>
            import(
              /* webpackChunkName: "CardTypesFs" */
              '../components/shared/CardFs/CardTypes/CardTypesFs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const CardTypesFs_styles = loadable(() =>
            import(
              /* webpackChunkName: "CardTypesFs.styles" */
              '../components/shared/CardFs/CardTypes/CardTypesFs.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ArticleCardFs = loadable(() =>
            import(
              /* webpackChunkName: "ArticleCardFs" */
              '../components/shared/CardFs/CardTypes/article/ArticleCardFs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ContentCardFs = loadable(() =>
            import(
              /* webpackChunkName: "ContentCardFs" */
              '../components/shared/CardFs/CardTypes/content/ContentCardFs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const PageCardFs = loadable(() =>
            import(
              /* webpackChunkName: "PageCardFs" */
              '../components/shared/CardFs/CardTypes/page/PageCardFs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductCardFs = loadable(() =>
            import(
              /* webpackChunkName: "ProductCardFs" */
              '../components/shared/CardFs/CardTypes/product/ProductCardFs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ProductPromoCardFs = loadable(() =>
            import(
              /* webpackChunkName: "ProductPromoCardFs" */
              '../components/shared/CardFs/CardTypes/product/ProductPromoCardFs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipeCardFs = loadable(() =>
            import(
              /* webpackChunkName: "RecipeCardFs" */
              '../components/shared/CardFs/CardTypes/recipe/RecipeCardFs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipePromoCardFs = loadable(() =>
            import(
              /* webpackChunkName: "RecipePromoCardFs" */
              '../components/shared/CardFs/CardTypes/recipe/RecipePromoCardFs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const RelatedCardFs = loadable(() =>
            import(
              /* webpackChunkName: "RelatedCardFs" */
              '../components/shared/CardFs/CardTypes/related/RelatedCardFs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Carousel = loadable(() =>
            import(
              /* webpackChunkName: "Carousel" */
              '../components/shared/Carousel/Carousel.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Carousel_styles = loadable(() =>
            import(
              /* webpackChunkName: "Carousel.styles" */
              '../components/shared/Carousel/Carousel.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FeaturedProduct = loadable(() =>
            import(
              /* webpackChunkName: "FeaturedProduct" */
              '../components/shared/FeaturedProduct/FeaturedProduct.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FeaturedProduct_styles = loadable(() =>
            import(
              /* webpackChunkName: "FeaturedProduct.styles" */
              '../components/shared/FeaturedProduct/FeaturedProduct.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Grid = loadable(() =>
            import(
              /* webpackChunkName: "Grid" */
              '../components/shared/Grid/Grid.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Grid_style = loadable(() =>
            import(
              /* webpackChunkName: "Grid.style" */
              '../components/shared/Grid/Grid.style.js'
            ),
            { fallback: <Skeleton /> }
          );

          const GridFs = loadable(() =>
            import(
              /* webpackChunkName: "GridFs" */
              '../components/shared/GridFs/GridFs.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const GridFs_style = loadable(() =>
            import(
              /* webpackChunkName: "GridFs.style" */
              '../components/shared/GridFs/GridFs.style.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Icon = loadable(() =>
            import(
              /* webpackChunkName: "Icon" */
              '../components/shared/Icon/Icon.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Icon_styles = loadable(() =>
            import(
              /* webpackChunkName: "Icon.styles" */
              '../components/shared/Icon/Icon.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Input = loadable(() =>
            import(
              /* webpackChunkName: "Input" */
              '../components/shared/Input/Input.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Input_styles = loadable(() =>
            import(
              /* webpackChunkName: "Input.styles" */
              '../components/shared/Input/Input.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const BeanCheck = loadable(() =>
            import(
              /* webpackChunkName: "BeanCheck" */
              '../components/shared/Input/components/BeanCheck.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Checkbox = loadable(() =>
            import(
              /* webpackChunkName: "Checkbox" */
              '../components/shared/Input/components/Checkbox.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Radio = loadable(() =>
            import(
              /* webpackChunkName: "Radio" */
              '../components/shared/Input/components/Radio.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const TextInput = loadable(() =>
            import(
              /* webpackChunkName: "TextInput" */
              '../components/shared/Input/components/TextInput.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const InterruptorRibbon = loadable(() =>
            import(
              /* webpackChunkName: "InterruptorRibbon" */
              '../components/shared/InterruptorRibbon/InterruptorRibbon.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const InterruptorRibbon_styles = loadable(() =>
            import(
              /* webpackChunkName: "InterruptorRibbon.styles" */
              '../components/shared/InterruptorRibbon/InterruptorRibbon.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const JssOverridesRichText = loadable(() =>
            import(
              /* webpackChunkName: "JssOverridesRichText" */
              '../components/shared/JssOverridesRichText.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const JssOverridesText = loadable(() =>
            import(
              /* webpackChunkName: "JssOverridesText" */
              '../components/shared/JssOverridesText.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Link = loadable(() =>
            import(
              /* webpackChunkName: "Link" */
              '../components/shared/Link/Link.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Listing = loadable(() =>
            import(
              /* webpackChunkName: "Listing" */
              '../components/shared/Listing/Listing.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Listing_styles = loadable(() =>
            import(
              /* webpackChunkName: "Listing.styles" */
              '../components/shared/Listing/Listing.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ListingError = loadable(() =>
            import(
              /* webpackChunkName: "ListingError" */
              '../components/shared/Listing/components/Error/ListingError.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const FilterFooter = loadable(() =>
            import(
              /* webpackChunkName: "FilterFooter" */
              '../components/shared/Listing/components/Filters/FilterFooter.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FilterHeader = loadable(() =>
            import(
              /* webpackChunkName: "FilterHeader" */
              '../components/shared/Listing/components/Filters/FilterHeader.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FilterOptions = loadable(() =>
            import(
              /* webpackChunkName: "FilterOptions" */
              '../components/shared/Listing/components/Filters/FilterOptions.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Filters_config = loadable(() =>
            import(
              /* webpackChunkName: "Filters.config" */
              '../components/shared/Listing/components/Filters/Filters.config.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Filters_styles = loadable(() =>
            import(
              /* webpackChunkName: "Filters.styles" */
              '../components/shared/Listing/components/Filters/Filters.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ListingFilters = loadable(() =>
            import(
              /* webpackChunkName: "ListingFilters" */
              '../components/shared/Listing/components/Filters/ListingFilters.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const NoResults = loadable(() =>
            import(
              /* webpackChunkName: "NoResults" */
              '../components/shared/Listing/components/Results/NoResults.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Results = loadable(() =>
            import(
              /* webpackChunkName: "Results" */
              '../components/shared/Listing/components/Results/Results.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Results_styles = loadable(() =>
            import(
              /* webpackChunkName: "Results.styles" */
              '../components/shared/Listing/components/Results/Results.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SVGspiral = loadable(() =>
            import(
              /* webpackChunkName: "SVGspiral" */
              '../components/shared/Listing/components/svg/SVGspiral.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SvgSpiral_styles = loadable(() =>
            import(
              /* webpackChunkName: "SvgSpiral.styles" */
              '../components/shared/Listing/components/svg/SvgSpiral.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ListingFs = loadable(() =>
            import(
              /* webpackChunkName: "ListingFs" */
              '../components/shared/ListingFs/ListingFs.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ListingFs_styles = loadable(() =>
            import(
              /* webpackChunkName: "ListingFs.styles" */
              '../components/shared/ListingFs/ListingFs.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ListingErrorFs = loadable(() =>
            import(
              /* webpackChunkName: "ListingErrorFs" */
              '../components/shared/ListingFs/componentsFs/ErrorFs/ListingErrorFs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FilterFooterFs = loadable(() =>
            import(
              /* webpackChunkName: "FilterFooterFs" */
              '../components/shared/ListingFs/componentsFs/FiltersFs/FilterFooterFs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FilterHeaderFs = loadable(() =>
            import(
              /* webpackChunkName: "FilterHeaderFs" */
              '../components/shared/ListingFs/componentsFs/FiltersFs/FilterHeaderFs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FilterOptionsFs = loadable(() =>
            import(
              /* webpackChunkName: "FilterOptionsFs" */
              '../components/shared/ListingFs/componentsFs/FiltersFs/FilterOptionsFs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FiltersFs_config = loadable(() =>
            import(
              /* webpackChunkName: "FiltersFs.config" */
              '../components/shared/ListingFs/componentsFs/FiltersFs/FiltersFs.config.js'
            ),
            { fallback: <Skeleton /> }
          );

          const FiltersFs_styles = loadable(() =>
            import(
              /* webpackChunkName: "FiltersFs.styles" */
              '../components/shared/ListingFs/componentsFs/FiltersFs/FiltersFs.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ListingFiltersFs = loadable(() =>
            import(
              /* webpackChunkName: "ListingFiltersFs" */
              '../components/shared/ListingFs/componentsFs/FiltersFs/ListingFiltersFs.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const NoResultsFs = loadable(() =>
            import(
              /* webpackChunkName: "NoResultsFs" */
              '../components/shared/ListingFs/componentsFs/ResultsFs/NoResultsFs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ResultsFs = loadable(() =>
            import(
              /* webpackChunkName: "ResultsFs" */
              '../components/shared/ListingFs/componentsFs/ResultsFs/ResultsFs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ResultsFs_styles = loadable(() =>
            import(
              /* webpackChunkName: "ResultsFs.styles" */
              '../components/shared/ListingFs/componentsFs/ResultsFs/ResultsFs.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const LoadingIcon = loadable(() =>
            import(
              /* webpackChunkName: "LoadingIcon" */
              '../components/shared/LoadingIcon.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const LoadingSpinner = loadable(() =>
            import(
              /* webpackChunkName: "LoadingSpinner" */
              '../components/shared/LoadingSpinner/LoadingSpinner.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const LoadingSpinner_styles = loadable(() =>
            import(
              /* webpackChunkName: "LoadingSpinner.styles" */
              '../components/shared/LoadingSpinner/LoadingSpinner.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Modal = loadable(() =>
            import(
              /* webpackChunkName: "Modal" */
              '../components/shared/Modal/Modal.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Modal_style = loadable(() =>
            import(
              /* webpackChunkName: "Modal.style" */
              '../components/shared/Modal/Modal.style.js'
            ),
            { fallback: <Skeleton /> }
          );

          const NutritionTable = loadable(() =>
            import(
              /* webpackChunkName: "NutritionTable" */
              '../components/shared/NutritionTable/NutritionTable.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const NutritionTable_styles = loadable(() =>
            import(
              /* webpackChunkName: "NutritionTable.styles" */
              '../components/shared/NutritionTable/NutritionTable.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Overlay = loadable(() =>
            import(
              /* webpackChunkName: "Overlay" */
              '../components/shared/Overlay/Overlay.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Overlay_styles = loadable(() =>
            import(
              /* webpackChunkName: "Overlay.styles" */
              '../components/shared/Overlay/Overlay.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Portal = loadable(() =>
            import(
              /* webpackChunkName: "Portal" */
              '../components/shared/Portal/Portal.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const PromoBox = loadable(() =>
            import(
              /* webpackChunkName: "PromoBox" */
              '../components/shared/PromoBox/PromoBox.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const PromoBox_styles = loadable(() =>
            import(
              /* webpackChunkName: "PromoBox.styles" */
              '../components/shared/PromoBox/PromoBox.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipeWrapper = loadable(() =>
            import(
              /* webpackChunkName: "RecipeWrapper" */
              '../components/shared/RecipeWrapper/RecipeWrapper.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const RecipeWrapper_styles = loadable(() =>
            import(
              /* webpackChunkName: "RecipeWrapper.styles" */
              '../components/shared/RecipeWrapper/RecipeWrapper.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Ribbon = loadable(() =>
            import(
              /* webpackChunkName: "Ribbon" */
              '../components/shared/Ribbon/Ribbon.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Ribbon_styles = loadable(() =>
            import(
              /* webpackChunkName: "Ribbon.styles" */
              '../components/shared/Ribbon/Ribbon.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const ScrollingText = loadable(() =>
            import(
              /* webpackChunkName: "ScrollingText" */
              '../components/shared/ScrollingText/ScrollingText.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ScrollingText_styles = loadable(() =>
            import(
              /* webpackChunkName: "ScrollingText.styles" */
              '../components/shared/ScrollingText/ScrollingText.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SearchResultComponent = loadable(() =>
            import(
              /* webpackChunkName: "SearchResultComponent" */
              '../components/shared/SearchResultComponent/SearchResultComponent.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SearchResultComponent_styles = loadable(() =>
            import(
              /* webpackChunkName: "SearchResultComponent.styles" */
              '../components/shared/SearchResultComponent/SearchResultComponent.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Select = loadable(() =>
            import(
              /* webpackChunkName: "Select" */
              '../components/shared/Select/Select.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Select_styles = loadable(() =>
            import(
              /* webpackChunkName: "Select.styles" */
              '../components/shared/Select/Select.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Separator = loadable(() =>
            import(
              /* webpackChunkName: "Separator" */
              '../components/shared/Separator.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SocialLinks = loadable(() =>
            import(
              /* webpackChunkName: "SocialLinks" */
              '../components/shared/SocialLinks/SocialLinks.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SocialLinks_styles = loadable(() =>
            import(
              /* webpackChunkName: "SocialLinks.styles" */
              '../components/shared/SocialLinks/SocialLinks.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Subscribe = loadable(() =>
            import(
              /* webpackChunkName: "Subscribe" */
              '../components/shared/Subscribe/Subscribe.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Subscribe_style = loadable(() =>
            import(
              /* webpackChunkName: "Subscribe.style" */
              '../components/shared/Subscribe/Subscribe.style.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Textarea = loadable(() =>
            import(
              /* webpackChunkName: "Textarea" */
              '../components/shared/Textarea/Textarea.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Textarea_styles = loadable(() =>
            import(
              /* webpackChunkName: "Textarea.styles" */
              '../components/shared/Textarea/Textarea.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Tooltip = loadable(() =>
            import(
              /* webpackChunkName: "Tooltip" */
              '../components/shared/Tooltip/Tooltip.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Tooltip_styles = loadable(() =>
            import(
              /* webpackChunkName: "Tooltip.styles" */
              '../components/shared/Tooltip/Tooltip.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const VanityStrip = loadable(() =>
            import(
              /* webpackChunkName: "VanityStrip" */
              '../components/shared/VanityStrip/VanityStrip.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const VanityStrip_styles = loadable(() =>
            import(
              /* webpackChunkName: "VanityStrip.styles" */
              '../components/shared/VanityStrip/VanityStrip.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const SVGspiralImg = loadable(() =>
            import(
              /* webpackChunkName: "SVGspiralImg" */
              '../components/shared/Video/InlineSvg/SVGspiralImg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const SvgSpiralImg_styles = loadable(() =>
            import(
              /* webpackChunkName: "SvgSpiralImg.styles" */
              '../components/shared/Video/InlineSvg/SvgSpiralImg.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const VideoPlayBtn = loadable(() =>
            import(
              /* webpackChunkName: "VideoPlayBtn" */
              '../components/shared/Video/InlineSvg/VideoPlayBtn.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Video = loadable(() =>
            import(
              /* webpackChunkName: "Video" */
              '../components/shared/Video/Video.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const Video_styles = loadable(() =>
            import(
              /* webpackChunkName: "Video.styles" */
              '../components/shared/Video/Video.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_ComponentParams = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-ComponentParams" */
              '../components/styleguide/Styleguide-ComponentParams.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_CustomRouteType = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-CustomRouteType" */
              '../components/styleguide/Styleguide-CustomRouteType.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_EditFrame = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-EditFrame" */
              '../components/styleguide/Styleguide-EditFrame.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_Layout_Reuse = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-Layout-Reuse" */
              '../components/styleguide/Styleguide-Layout-Reuse.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_Layout_Tabs_Tab = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-Layout-Tabs-Tab" */
              '../components/styleguide/Styleguide-Layout-Tabs-Tab.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_Layout_Tabs = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-Layout-Tabs" */
              '../components/styleguide/Styleguide-Layout-Tabs.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_Layout = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-Layout" */
              '../components/styleguide/Styleguide-Layout.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_Multilingual = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-Multilingual" */
              '../components/styleguide/Styleguide-Multilingual.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_RouteFields = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-RouteFields" */
              '../components/styleguide/Styleguide-RouteFields.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_Section = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-Section" */
              '../components/styleguide/Styleguide-Section.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_SitecoreContext = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-SitecoreContext" */
              '../components/styleguide/Styleguide-SitecoreContext.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_Specimen = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-Specimen" */
              '../components/styleguide/Styleguide-Specimen.js'
            ),
            { fallback: <Skeleton /> }
          );

          const Styleguide_Tracking = loadable(() =>
            import(
              /* webpackChunkName: "Styleguide-Tracking" */
              '../components/styleguide/Styleguide-Tracking.js'
            ),
            { fallback: <Skeleton /> }
          );

          const DownloadSvg = loadable(() =>
            import(
              /* webpackChunkName: "DownloadSvg" */
              '../components/svg/DownloadSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const ShareIconSvg = loadable(() =>
            import(
              /* webpackChunkName: "ShareIconSvg" */
              '../components/svg/ShareIconSvg.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const videoSlider = loadable(() =>
            import(
              /* webpackChunkName: "videoSlider" */
              '../components/videoSlider/videoSlider.jsx'
            ),
            { fallback: <Skeleton /> }
          );

          const videoSlider_styles = loadable(() =>
            import(
              /* webpackChunkName: "videoSlider.styles" */
              '../components/videoSlider/videoSlider.styles.js'
            ),
            { fallback: <Skeleton /> }
          );

const components = new Map();
components.set('Accordion', Accordion);
components.set('Accordion.styles', Accordion_styles);
components.set('AccordionSection', AccordionSection);
components.set('AccordionSection.styles', AccordionSection_styles);
components.set('AlertRibbon', AlertRibbon);
components.set('AlertRibbon.styles', AlertRibbon_styles);
components.set('ArticleGrid', ArticleGrid);
components.set('ArticleGrid.styles', ArticleGrid_styles);
components.set('BackgroundImageWithTextTop', BackgroundImageWithTextTop);
components.set('BackgroundImageWithTextTop.styles', BackgroundImageWithTextTop_styles);
components.set('Banner', Banner);
components.set('Banner.styles', Banner_styles);
components.set('BeautifulBeanFootageTVSvg', BeautifulBeanFootageTVSvg);
components.set('BeautifulBeanFootageTVSvg.styles', BeautifulBeanFootageTVSvg_styles);
components.set('BlogAccordion', BlogAccordion);
components.set('BlogAccordion.styles', BlogAccordion_styles);
components.set('BlogAccordionSection', BlogAccordionSection);
components.set('BlogAccordionSection.styles', BlogAccordionSection_styles);
components.set('BlueyBeanChallenge', BlueyBeanChallenge);
components.set('BlueyBeanChallenge.styles', BlueyBeanChallenge_styles);
components.set('CallToAction', CallToAction);
components.set('CallToAction.styles', CallToAction_styles);
components.set('CareersHero', CareersHero);
components.set('CareersHero.styles', CareersHero_styles);
components.set('SvgBorder', SvgBorder);
components.set('CareersLocations', CareersLocations);
components.set('CareersLocations.styles', CareersLocations_styles);
components.set('CenteredTextVideo', CenteredTextVideo);
components.set('CenteredTextVideo.styles', CenteredTextVideo_styles);
components.set('ConcaveBorder', ConcaveBorder);
components.set('ConcaveHero', ConcaveHero);
components.set('ConcaveHero.styles', ConcaveHero_styles);
components.set('ContactRepForm', ContactRepForm);
components.set('ContactRepForm.styles', ContactRepForm_styles);
components.set('ContactRepHero', ContactRepHero);
components.set('ContactUsForm', ContactUsForm);
components.set('ContactUsForm.styles', ContactUsForm_styles);
components.set('ContactUsHero', ContactUsHero);
components.set('Content', Content);
components.set('Content.styles', Content_styles);
components.set('ContentBlock', ContentBlock);
components.set('ContentBlock.styles', ContentBlock_styles);
components.set('ContentCard', ContentCard);
components.set('ContentCard.styles', ContentCard_styles);
components.set('ContentCardContainer', ContentCardContainer);
components.set('ContentCardContainer.styles', ContentCardContainer_styles);
components.set('CookiePolicy', CookiePolicy);
components.set('CookiePolicy.styles', CookiePolicy_styles);
components.set('CountdownTimer', CountdownTimer);
components.set('CountdownTimer.styles', CountdownTimer_styles);
components.set('DualInfoBoxes', DualInfoBoxes);
components.set('DualInfoBoxes.styles', DualInfoBoxes_styles);
components.set('FavoritesGrid', FavoritesGrid);
components.set('FavoritesGrid.styles', FavoritesGrid_styles);
components.set('FeaturedDetailHero', FeaturedDetailHero);
components.set('FeaturedDetailHero.styles', FeaturedDetailHero_styles);
components.set('ArticlePromo', ArticlePromo);
components.set('ArticlePromo.styles', ArticlePromo_styles);
components.set('GeneralPromo', GeneralPromo);
components.set('GeneralPromo.styles', GeneralPromo_styles);
components.set('RecipePromo', RecipePromo);
components.set('RecipePromo.styles', RecipePromo_styles);
components.set('promoVariantColours', promoVariantColours);
components.set('FeaturedDetailHeroWithVideo', FeaturedDetailHeroWithVideo);
components.set('FeaturedDetailHeroWithVideo.styles', FeaturedDetailHeroWithVideo_styles);
components.set('FeaturedFacts', FeaturedFacts);
components.set('FeaturedFacts.styles', FeaturedFacts_styles);
components.set('FeaturedRecipePromo', FeaturedRecipePromo);
components.set('FeaturedRecipePromo.styles', FeaturedRecipePromo_styles);
components.set('FindInStoreSearchDestiny', FindInStoreSearchDestiny);
components.set('FindInStoreSearchDestiny.styles', FindInStoreSearchDestiny_styles);
components.set('FindNearYou', FindNearYou);
components.set('FindNearYou.styles', FindNearYou_styles);
components.set('BottomBorder', BottomBorder);
components.set('FlavorHero', FlavorHero);
components.set('FlavorHero.styles', FlavorHero_styles);
components.set('SpiralCircle', SpiralCircle);
components.set('FlavorIdeaPromo', FlavorIdeaPromo);
components.set('FlavorIdeaPromo.styles', FlavorIdeaPromo_styles);
components.set('FlavorSubmissionForm', FlavorSubmissionForm);
components.set('FlavorSubmissionForm.styles', FlavorSubmissionForm_styles);
components.set('Footer', Footer);
components.set('Footer.styles', Footer_styles);
components.set('LinksList', LinksList);
components.set('SubscribeLoader', SubscribeLoader);
components.set('Game', Game);
components.set('Game.styles', Game_styles);
components.set('GameEmbed', GameEmbed);
components.set('GameEmbed.styles', GameEmbed_styles);
components.set('Background', Background);
components.set('GridIron', GridIron);
components.set('GridIron.styles', GridIron_styles);
components.set('Obstacle', Obstacle);
components.set('Player', Player);
components.set('constants', constants);
components.set('types', types);
components.set('useGameLoop', useGameLoop);
components.set('HeroCarousel', HeroCarousel);
components.set('HeroCarousel.styles', HeroCarousel_styles);
components.set('HeroCarouselSlide', HeroCarouselSlide);
components.set('HeroCarouselSlide.styles', HeroCarouselSlide_styles);
components.set('HeroButtons', HeroButtons);
components.set('HeroWithTextLeft', HeroWithTextLeft);
components.set('HeroWithTextLeft.styles', HeroWithTextLeft_styles);
components.set('clouds', clouds);
components.set('HomepageHeroCarousel', HomepageHeroCarousel);
components.set('HomepageHeroCarousel.styles', HomepageHeroCarousel_styles);
components.set('HomepageHeroCarouselSlide', HomepageHeroCarouselSlide);
components.set('HomepageHeroCarouselSlide.styles', HomepageHeroCarouselSlide_styles);
components.set('IconButton', IconButton);
components.set('IconButton.styles', IconButton_styles);
components.set('IconList', IconList);
components.set('IconList.styles', IconList_styles);
components.set('IconListItem', IconListItem);
components.set('ImageCTA', ImageCTA);
components.set('ImageComparisonFullWidth', ImageComparisonFullWidth);
components.set('ImageComparisonFullWidth.styles', ImageComparisonFullWidth_styles);
components.set('ImageSlider', ImageSlider);
components.set('ImageSlider.styles', ImageSlider_styles);
components.set('ImageSliderAlt', ImageSliderAlt);
components.set('ImageSliderAlt.styles', ImageSliderAlt_styles);
components.set('ImageSliderSlide', ImageSliderSlide);
components.set('ImageSliderSlide.styles', ImageSliderSlide_styles);
components.set('ImageWithTextBoxOverlap', ImageWithTextBoxOverlap);
components.set('ImageWithTextBoxOverlap.styles', ImageWithTextBoxOverlap_styles);
components.set('ImageWithTextBoxOverlapItem', ImageWithTextBoxOverlapItem);
components.set('ImageWithTextBoxOverlapItem.styles', ImageWithTextBoxOverlapItem_styles);
components.set('InRecipeProductsFoodservices', InRecipeProductsFoodservices);
components.set('InRecipeProductsFoodservices.styles', InRecipeProductsFoodservices_styles);
components.set('InRecipeProductsPromo', InRecipeProductsPromo);
components.set('InRecipeProductsPromo.styles', InRecipeProductsPromo_styles);
components.set('LandingHero', LandingHero);
components.set('LandingHero.styles', LandingHero_styles);
components.set('LazyImage', LazyImage);
components.set('DesktopNav', DesktopNav);
components.set('DesktopNav.styles', DesktopNav_styles);
components.set('FsDesktopNav', FsDesktopNav);
components.set('FsDesktopNav.styles', FsDesktopNav_styles);
components.set('FsHamburger', FsHamburger);
components.set('FsHamburger.styles', FsHamburger_styles);
components.set('FsMainNavAboutUsLink', FsMainNavAboutUsLink);
components.set('FsMainNavAboutUsLink.styles', FsMainNavAboutUsLink_styles);
components.set('FsMainNavCardLink', FsMainNavCardLink);
components.set('FsMainNavCardLink.styles', FsMainNavCardLink_styles);
components.set('FsMainNavProductLink', FsMainNavProductLink);
components.set('FsMainNavProductLink.styles', FsMainNavProductLink_styles);
components.set('FsMobileNav', FsMobileNav);
components.set('FsMobileNav.styles', FsMobileNav_styles);
components.set('Hamburger', Hamburger);
components.set('Hamburger.styles', Hamburger_styles);
components.set('MainNavAboutUsLink', MainNavAboutUsLink);
components.set('MainNavAboutUsLink.styles', MainNavAboutUsLink_styles);
components.set('MainNavProductLink', MainNavProductLink);
components.set('MainNavProductLink.styles', MainNavProductLink_styles);
components.set('MainNavRibbon', MainNavRibbon);
components.set('MainNavRibbon.styles', MainNavRibbon_styles);
components.set('MainNavRibbonCta', MainNavRibbonCta);
components.set('MainNavRibbonCta.styles', MainNavRibbonCta_styles);
components.set('MobileNav', MobileNav);
components.set('MobileNav.styles', MobileNav_styles);
components.set('MainNav', MainNav);
components.set('MainNav.styles', MainNav_styles);
components.set('MediaCarousel', MediaCarousel);
components.set('MediaCarousel.styles', MediaCarousel_styles);
components.set('MediaCarouselImageSlide', MediaCarouselImageSlide);
components.set('MediaCarouselImageSlide.styles', MediaCarouselImageSlide_styles);
components.set('MediaCarouselVideoSlide', MediaCarouselVideoSlide);
components.set('MediaCarouselVideoSlide.styles', MediaCarouselVideoSlide_styles);
components.set('MultiLinkCta', MultiLinkCta);
components.set('MultiLinkCta.styles', MultiLinkCta_styles);
components.set('NavLink', NavLink);
components.set('NavLink.styles', NavLink_styles);
components.set('NotFound', NotFound);
components.set('NotFound.styles', NotFound_styles);
components.set('NutritionLabelTable', NutritionLabelTable);
components.set('OffsetFeaturePromo', OffsetFeaturePromo);
components.set('OffsetFeaturePromo.styles', OffsetFeaturePromo_styles);
components.set('OverTheTopSurveyEmbed', OverTheTopSurveyEmbed);
components.set('OverTheTopSurveyEmbed.styles', OverTheTopSurveyEmbed_styles);
components.set('PageBanner', PageBanner);
components.set('PageBanner.styles', PageBanner_styles);
components.set('PardotSampleRequestForm', PardotSampleRequestForm);
components.set('PardotSampleRequestForm.styles', PardotSampleRequestForm_styles);
components.set('ProductCTA', ProductCTA);
components.set('ProductCTA.styles', ProductCTA_styles);
components.set('ProductCanShowcase', ProductCanShowcase);
components.set('ProductDescription', ProductDescription);
components.set('ProductDescription.styles', ProductDescription_styles);
components.set('ProductDetailHero', ProductDetailHero);
components.set('ProductDetailHero.styles', ProductDetailHero_styles);
components.set('ProductGrid', ProductGrid);
components.set('ProductGrid.styles', ProductGrid_styles);
components.set('ProductIngredientBenefitsPromo.config', ProductIngredientBenefitsPromo_config);
components.set('ProductIngredientBenefitsPromo', ProductIngredientBenefitsPromo);
components.set('ProductIngredientBenefitsPromo.styles', ProductIngredientBenefitsPromo_styles);
components.set('ProductListCarousel', ProductListCarousel);
components.set('ProductListCarousel.styles', ProductListCarousel_styles);
components.set('ProductNutritionLabelPromo', ProductNutritionLabelPromo);
components.set('ProductNutritionLabelPromo.styles', ProductNutritionLabelPromo_styles);
components.set('PromoHero', PromoHero);
components.set('PromoHero.styles', PromoHero_styles);
components.set('RecipeDirectionDetails', RecipeDirectionDetails);
components.set('RecipeDirectionDetails.styles', RecipeDirectionDetails_styles);
components.set('RecipeGrid', RecipeGrid);
components.set('RecipeGrid.styles', RecipeGrid_styles);
components.set('RecipeIngredientsDetails', RecipeIngredientsDetails);
components.set('RecipeIngredientsDetails.styles', RecipeIngredientsDetails_styles);
components.set('RecipeOverview', RecipeOverview);
components.set('RecipeOverview.styles', RecipeOverview_styles);
components.set('RecipeOverviewDirect', RecipeOverviewDirect);
components.set('RecommendRecipe', RecommendRecipe);
components.set('RecommendRecipe.styles', RecommendRecipe_styles);
components.set('RelatedCarousel', RelatedCarousel);
components.set('RelatedCarousel.styles', RelatedCarousel_styles);
components.set('RelatedCarouselSlide', RelatedCarouselSlide);
components.set('RelatedCarouselSlide.styles', RelatedCarouselSlide_styles);
components.set('RelatedPagesGrid', RelatedPagesGrid);
components.set('RelatedPagesGrid.styles', RelatedPagesGrid_styles);
components.set('RelatedPagesPromo', RelatedPagesPromo);
components.set('RelatedPagesPromo.styles', RelatedPagesPromo_styles);
components.set('AltPromo', AltPromo);
components.set('BeanBqPromo', BeanBqPromo);
components.set('BlueyPromo', BlueyPromo);
components.set('DefaultPromo', DefaultPromo);
components.set('FeaturedPromo', FeaturedPromo);
components.set('FoodservicesPromo', FoodservicesPromo);
components.set('LandingSurveyPromo', LandingSurveyPromo);
components.set('cardShapeData', cardShapeData);
components.set('ScrollingImagesPromo', ScrollingImagesPromo);
components.set('ScrollingImagesPromo.styles', ScrollingImagesPromo_styles);
components.set('ScrollingImagesPromoSlide', ScrollingImagesPromoSlide);
components.set('ScrollingImagesPromoSlide.styles', ScrollingImagesPromoSlide_styles);
components.set('ScrollingVanityTextWithVideo', ScrollingVanityTextWithVideo);
components.set('ScrollingVanityTextWithVideo.styles', ScrollingVanityTextWithVideo_styles);
components.set('SearchBox', SearchBox);
components.set('SearchBox.styles', SearchBox_styles);
components.set('BeanSurprise', BeanSurprise);
components.set('SideBySide', SideBySide);
components.set('SideBySide.styles', SideBySide_styles);
components.set('SideBySideLargeImage', SideBySideLargeImage);
components.set('SideBySideLargeImage.styles', SideBySideLargeImage_styles);
components.set('HandleSvg', HandleSvg);
components.set('SideBySideRevealImage', SideBySideRevealImage);
components.set('SideBySideRevealImage.styles', SideBySideRevealImage_styles);
components.set('SideBySideVideo', SideBySideVideo);
components.set('SideBySideVideo.styles', SideBySideVideo_styles);
components.set('SingleCenteredVideo', SingleCenteredVideo);
components.set('SingleCenteredVideo.styles', SingleCenteredVideo_styles);
components.set('SiteSearchResults', SiteSearchResults);
components.set('SiteSearchResults.styles', SiteSearchResults_styles);
components.set('SmallImageWithText', SmallImageWithText);
components.set('SmallImageWithText.styles', SmallImageWithText_styles);
components.set('SmallSideBySide', SmallSideBySide);
components.set('SmallSideBySide.styles', SmallSideBySide_styles);
components.set('SocialShare', SocialShare);
components.set('SocialShare.styles', SocialShare_styles);
components.set('SocialVideo', SocialVideo);
components.set('SocialVideo.styles', SocialVideo_styles);
components.set('VerticalLineDecorationSvg', VerticalLineDecorationSvg);
components.set('SocialVideoSlide', SocialVideoSlide);
components.set('SocialVideoSlide.styles', SocialVideoSlide_styles);
components.set('CirclePlayBtnSvg', CirclePlayBtnSvg);
components.set('SustainabilityFeatureCards', SustainabilityFeatureCards);
components.set('SustainabilitySlider', SustainabilitySlider);
components.set('SustainabilityStats', SustainabilityStats);
components.set('SustainabilityVideoHero', SustainabilityVideoHero);
components.set('NutritionLabelTableCA', NutritionLabelTableCA);
components.set('NutritionLabelTableCA.styles', NutritionLabelTableCA_styles);
components.set('NutritionLabelTableUS', NutritionLabelTableUS);
components.set('NutritionLabelTableUS.styles', NutritionLabelTableUS_styles);
components.set('TestComponent', TestComponent);
components.set('TestimonialCarousel', TestimonialCarousel);
components.set('TestimonialCarousel.styles', TestimonialCarousel_styles);
components.set('TestimonialCarouselSlide', TestimonialCarouselSlide);
components.set('TestimonialCarouselSlide.styles', TestimonialCarouselSlide_styles);
components.set('AlchemerSurvey', AlchemerSurvey);
components.set('AlchemerSurvey.styles', AlchemerSurvey_styles);
components.set('AlchemerSurveyIframe', AlchemerSurveyIframe);
components.set('AlchemerSurveyOnPage', AlchemerSurveyOnPage);
components.set('BeanGameComponent', BeanGameComponent);
components.set('BeanGameComponent.styles', BeanGameComponent_styles);
components.set('CenteredVideo', CenteredVideo);
components.set('CenteredVideo.styles', CenteredVideo_styles);
components.set('CenteredVideoComponent', CenteredVideoComponent);
components.set('CenteredVideoComponent.styles', CenteredVideoComponent_styles);
components.set('BeanAndBurst', BeanAndBurst);
components.set('DukeBlueBean', DukeBlueBean);
components.set('DukeInBeanSvg', DukeInBeanSvg);
components.set('DukeInBeanSvg.styles', DukeInBeanSvg_styles);
components.set('DukeTalkBubbleSmallSvg', DukeTalkBubbleSmallSvg);
components.set('DukeTalkBubbleSvg', DukeTalkBubbleSvg);
components.set('JayDukeSecretFamilyRecipeSvg', JayDukeSecretFamilyRecipeSvg);
components.set('JayDukeSecretFamilyRecipeSvg.style', JayDukeSecretFamilyRecipeSvg_style);
components.set('NineteenNfourSvg', NineteenNfourSvg);
components.set('NineteenNfourSvg.styles', NineteenNfourSvg_styles);
components.set('PlayBtnSvg', PlayBtnSvg);
components.set('PlayCutOutSvg', PlayCutOutSvg);
components.set('SoDarnGoodBBLogoSvg', SoDarnGoodBBLogoSvg);
components.set('SoDarnGoodBBLogoSvg.styles', SoDarnGoodBBLogoSvg_styles);
components.set('SoDarnGoodCSvg', SoDarnGoodCSvg);
components.set('SoDarnGoodCSvg.styles', SoDarnGoodCSvg_styles);
components.set('SoDarnGoodCirclePlateSvg', SoDarnGoodCirclePlateSvg);
components.set('SoDarnGoodESvg', SoDarnGoodESvg);
components.set('SoDarnGoodESvg.styles', SoDarnGoodESvg_styles);
components.set('ThirtyKSvg', ThirtyKSvg);
components.set('ThirtyKSvg.styles', ThirtyKSvg_styles);
components.set('MinesweeperIframe', MinesweeperIframe);
components.set('NewsletterFormComponent', NewsletterFormComponent);
components.set('OverTheTopIframe', OverTheTopIframe);
components.set('OverTheTopSurvey', OverTheTopSurvey);
components.set('OverTheTopSurvey.styles', OverTheTopSurvey_styles);
components.set('SampleRequestForm', SampleRequestForm);
components.set('SampleRequestForm.styles', SampleRequestForm_styles);
components.set('SocialMediaComponent', SocialMediaComponent);
components.set('SocialMediaComponent.styles', SocialMediaComponent_styles);
components.set('UpdBeanGameComponent', UpdBeanGameComponent);
components.set('VideoPlayer', VideoPlayer);
components.set('VideoRightComponent', VideoRightComponent);
components.set('VideoRightComponent.styles', VideoRightComponent_styles);
components.set('VideoTimelineComponent', VideoTimelineComponent);
components.set('VideoTimelineComponent.styles', VideoTimelineComponent_styles);
components.set('VideoTimelineYoutubePlayer', VideoTimelineYoutubePlayer);
components.set('YouMadeIt', YouMadeIt);
components.set('Text', Text);
components.set('Text.styles', Text_styles);
components.set('TextDualImage', TextDualImage);
components.set('TextDualImage.styles', TextDualImage_styles);
components.set('TextImageSwap', TextImageSwap);
components.set('TextImageSwap.styles', TextImageSwap_styles);
components.set('SvgSmileyTBBC', SvgSmileyTBBC);
components.set('TextLeftFramedVideoRight', TextLeftFramedVideoRight);
components.set('TextLeftFramedVideoRight.styles', TextLeftFramedVideoRight_styles);
components.set('TextLeftVideoRight', TextLeftVideoRight);
components.set('TextLeftVideoRight.styles', TextLeftVideoRight_styles);
components.set('TextWithImages', TextWithImages);
components.set('TextWithImages.styles', TextWithImages_styles);
components.set('ThirtyYearsSvg', ThirtyYearsSvg);
components.set('ThirtyYearsSvg.styles', ThirtyYearsSvg_styles);
components.set('ThreeColShowcase', ThreeColShowcase);
components.set('ThreeColShowcase.styles', ThreeColShowcase_styles);
components.set('ThreeColumnSingleImage', ThreeColumnSingleImage);
components.set('ThreeColumnSingleImage.styles', ThreeColumnSingleImage_styles);
components.set('TvVideoFrame', TvVideoFrame);
components.set('TvVideoFrame.styles', TvVideoFrame_styles);
components.set('UtilityNav', UtilityNav);
components.set('VendorForm', VendorForm);
components.set('VendorForm.styles', VendorForm_styles);
components.set('VersusModule', VersusModule);
components.set('VersusModule.styles', VersusModule_styles);
components.set('CircularPlayBtnSvg', CircularPlayBtnSvg);
components.set('LookAndFind', LookAndFind);
components.set('LookAndFind.styles', LookAndFind_styles);
components.set('VerticalEmbedsVideo', VerticalEmbedsVideo);
components.set('VerticalEmbedsVideo.styles', VerticalEmbedsVideo_styles);
components.set('YoutubePlayerWindow', YoutubePlayerWindow);
components.set('VerticalEmbeds', VerticalEmbeds);
components.set('VerticalEmbeds.styles', VerticalEmbeds_styles);
components.set('VimeoVideo', VimeoVideo);
components.set('VimeoVideo.styles', VimeoVideo_styles);
components.set('VisitorCenterHours', VisitorCenterHours);
components.set('VisitorCenterHours.styles', VisitorCenterHours_styles);
components.set('YoutubePlayer', YoutubePlayer);
components.set('Styleguide-FieldUsage-Checkbox', Styleguide_FieldUsage_Checkbox);
components.set('Styleguide-FieldUsage-ContentList', Styleguide_FieldUsage_ContentList);
components.set('Styleguide-FieldUsage-Custom', Styleguide_FieldUsage_Custom);
components.set('Styleguide-FieldUsage-Date', Styleguide_FieldUsage_Date);
components.set('Styleguide-FieldUsage-File', Styleguide_FieldUsage_File);
components.set('Styleguide-FieldUsage-Image', Styleguide_FieldUsage_Image);
components.set('Styleguide-FieldUsage-ItemLink', Styleguide_FieldUsage_ItemLink);
components.set('Styleguide-FieldUsage-Link', Styleguide_FieldUsage_Link);
components.set('Styleguide-FieldUsage-Number', Styleguide_FieldUsage_Number);
components.set('Styleguide-FieldUsage-RichText', Styleguide_FieldUsage_RichText);
components.set('Styleguide-FieldUsage-Text', Styleguide_FieldUsage_Text);
components.set('GraphQL-ConnectedDemo', GraphQL_ConnectedDemo);
components.set('GraphQL-IntegratedDemo', GraphQL_IntegratedDemo);
components.set('GraphQL-Layout', GraphQL_Layout);
components.set('Button', Button);
components.set('Button.styles', Button_styles);
components.set('ButtonTypes', ButtonTypes);
components.set('Card', Card);
components.set('Card.styles', Card_styles);
components.set('CardTypes', CardTypes);
components.set('CardTypes.styles', CardTypes_styles);
components.set('ArticleCard', ArticleCard);
components.set('CardTypeContentCard', CardTypeContentCard);
components.set('FeaturedCard', FeaturedCard);
components.set('PageCard', PageCard);
components.set('ProductCard', ProductCard);
components.set('ProductPromoCard', ProductPromoCard);
components.set('RecipeCard', RecipeCard);
components.set('RecipePromoCard', RecipePromoCard);
components.set('RelatedCard', RelatedCard);
components.set('RelatedAltCard', RelatedAltCard);
components.set('CardFs', CardFs);
components.set('CardFs.styles', CardFs_styles);
components.set('CardTypesFs', CardTypesFs);
components.set('CardTypesFs.styles', CardTypesFs_styles);
components.set('ArticleCardFs', ArticleCardFs);
components.set('ContentCardFs', ContentCardFs);
components.set('PageCardFs', PageCardFs);
components.set('ProductCardFs', ProductCardFs);
components.set('ProductPromoCardFs', ProductPromoCardFs);
components.set('RecipeCardFs', RecipeCardFs);
components.set('RecipePromoCardFs', RecipePromoCardFs);
components.set('RelatedCardFs', RelatedCardFs);
components.set('Carousel', Carousel);
components.set('Carousel.styles', Carousel_styles);
components.set('FeaturedProduct', FeaturedProduct);
components.set('FeaturedProduct.styles', FeaturedProduct_styles);
components.set('Grid', Grid);
components.set('Grid.style', Grid_style);
components.set('GridFs', GridFs);
components.set('GridFs.style', GridFs_style);
components.set('Icon', Icon);
components.set('Icon.styles', Icon_styles);
components.set('Input', Input);
components.set('Input.styles', Input_styles);
components.set('BeanCheck', BeanCheck);
components.set('Checkbox', Checkbox);
components.set('Radio', Radio);
components.set('TextInput', TextInput);
components.set('InterruptorRibbon', InterruptorRibbon);
components.set('InterruptorRibbon.styles', InterruptorRibbon_styles);
components.set('JssOverridesRichText', JssOverridesRichText);
components.set('JssOverridesText', JssOverridesText);
components.set('Link', Link);
components.set('Listing', Listing);
components.set('Listing.styles', Listing_styles);
components.set('ListingError', ListingError);
components.set('FilterFooter', FilterFooter);
components.set('FilterHeader', FilterHeader);
components.set('FilterOptions', FilterOptions);
components.set('Filters.config', Filters_config);
components.set('Filters.styles', Filters_styles);
components.set('ListingFilters', ListingFilters);
components.set('NoResults', NoResults);
components.set('Results', Results);
components.set('Results.styles', Results_styles);
components.set('SVGspiral', SVGspiral);
components.set('SvgSpiral.styles', SvgSpiral_styles);
components.set('ListingFs', ListingFs);
components.set('ListingFs.styles', ListingFs_styles);
components.set('ListingErrorFs', ListingErrorFs);
components.set('FilterFooterFs', FilterFooterFs);
components.set('FilterHeaderFs', FilterHeaderFs);
components.set('FilterOptionsFs', FilterOptionsFs);
components.set('FiltersFs.config', FiltersFs_config);
components.set('FiltersFs.styles', FiltersFs_styles);
components.set('ListingFiltersFs', ListingFiltersFs);
components.set('NoResultsFs', NoResultsFs);
components.set('ResultsFs', ResultsFs);
components.set('ResultsFs.styles', ResultsFs_styles);
components.set('LoadingIcon', LoadingIcon);
components.set('LoadingSpinner', LoadingSpinner);
components.set('LoadingSpinner.styles', LoadingSpinner_styles);
components.set('Modal', Modal);
components.set('Modal.style', Modal_style);
components.set('NutritionTable', NutritionTable);
components.set('NutritionTable.styles', NutritionTable_styles);
components.set('Overlay', Overlay);
components.set('Overlay.styles', Overlay_styles);
components.set('Portal', Portal);
components.set('PromoBox', PromoBox);
components.set('PromoBox.styles', PromoBox_styles);
components.set('RecipeWrapper', RecipeWrapper);
components.set('RecipeWrapper.styles', RecipeWrapper_styles);
components.set('Ribbon', Ribbon);
components.set('Ribbon.styles', Ribbon_styles);
components.set('ScrollingText', ScrollingText);
components.set('ScrollingText.styles', ScrollingText_styles);
components.set('SearchResultComponent', SearchResultComponent);
components.set('SearchResultComponent.styles', SearchResultComponent_styles);
components.set('Select', Select);
components.set('Select.styles', Select_styles);
components.set('Separator', Separator);
components.set('SocialLinks', SocialLinks);
components.set('SocialLinks.styles', SocialLinks_styles);
components.set('Subscribe', Subscribe);
components.set('Subscribe.style', Subscribe_style);
components.set('Textarea', Textarea);
components.set('Textarea.styles', Textarea_styles);
components.set('Tooltip', Tooltip);
components.set('Tooltip.styles', Tooltip_styles);
components.set('VanityStrip', VanityStrip);
components.set('VanityStrip.styles', VanityStrip_styles);
components.set('SVGspiralImg', SVGspiralImg);
components.set('SvgSpiralImg.styles', SvgSpiralImg_styles);
components.set('VideoPlayBtn', VideoPlayBtn);
components.set('Video', Video);
components.set('Video.styles', Video_styles);
components.set('Styleguide-ComponentParams', Styleguide_ComponentParams);
components.set('Styleguide-CustomRouteType', Styleguide_CustomRouteType);
components.set('Styleguide-EditFrame', Styleguide_EditFrame);
components.set('Styleguide-Layout-Reuse', Styleguide_Layout_Reuse);
components.set('Styleguide-Layout-Tabs-Tab', Styleguide_Layout_Tabs_Tab);
components.set('Styleguide-Layout-Tabs', Styleguide_Layout_Tabs);
components.set('Styleguide-Layout', Styleguide_Layout);
components.set('Styleguide-Multilingual', Styleguide_Multilingual);
components.set('Styleguide-RouteFields', Styleguide_RouteFields);
components.set('Styleguide-Section', Styleguide_Section);
components.set('Styleguide-SitecoreContext', Styleguide_SitecoreContext);
components.set('Styleguide-Specimen', Styleguide_Specimen);
components.set('Styleguide-Tracking', Styleguide_Tracking);
components.set('DownloadSvg', DownloadSvg);
components.set('ShareIconSvg', ShareIconSvg);
components.set('videoSlider', videoSlider);
components.set('videoSlider.styles', videoSlider_styles);

export function componentFactory(componentName) {
  return components.get(componentName);
}
